export const cities = [
  {
    cityId: 1,
    cityName: "上海",
    cityEnName: "shanghai",
    cityAbbrCode: "sh",
    provinceId: 9,
    status: 3,
    regionCityId: 1,
    adCode: "310100",
    glng: 121.472916,
    hotCity: true,
    glat: 31.230708,
  },
  {
    cityId: 7,
    cityName: "深圳",
    cityEnName: "shenzhen",
    cityAbbrCode: "sz",
    provinceId: 19,
    status: 3,
    regionCityId: 7,
    adCode: "440300",
    glng: 114.057818,
    hotCity: true,
    glat: 22.543447,
  },
  {
    cityId: 2,
    cityName: "北京",
    cityEnName: "beijing",
    cityAbbrCode: "bj",
    provinceId: 1,
    status: 3,
    regionCityId: 2,
    adCode: "110100",
    glng: 116.408198,
    hotCity: true,
    glat: 39.904667,
  },
  {
    cityId: 8,
    cityName: "成都",
    cityEnName: "chengdu",
    cityAbbrCode: "cd",
    provinceId: 23,
    status: 3,
    regionCityId: 8,
    adCode: "510100",
    glng: 104.064857,
    hotCity: true,
    glat: 30.658602,
  },
  {
    cityId: 16,
    cityName: "武汉",
    cityEnName: "wuhan",
    cityAbbrCode: "wh",
    provinceId: 17,
    status: 3,
    regionCityId: 16,
    adCode: "420100",
    glng: 114.305172,
    hotCity: true,
    glat: 30.593088,
  },
  {
    cityId: 3,
    cityName: "杭州",
    cityEnName: "hangzhou",
    cityAbbrCode: "hz",
    provinceId: 11,
    status: 3,
    regionCityId: 3,
    adCode: "330100",
    glng: 120.155249,
    hotCity: true,
    glat: 30.273497,
  },
  {
    cityId: 5,
    cityName: "南京",
    cityEnName: "nanjing",
    cityAbbrCode: "nj",
    provinceId: 10,
    status: 3,
    regionCityId: 5,
    adCode: "320100",
    glng: 118.796468,
    hotCity: true,
    glat: 32.058365,
  },
  {
    cityId: 9,
    cityName: "重庆",
    cityEnName: "chongqing",
    cityAbbrCode: "cq",
    provinceId: 22,
    status: 3,
    regionCityId: 9,
    adCode: "500100",
    glng: 0,
    hotCity: true,
    glat: 29.562686,
  },
  {
    cityId: 4,
    cityName: "广州",
    cityEnName: "guangzhou",
    cityAbbrCode: "gz",
    provinceId: 19,
    status: 3,
    regionCityId: 4,
    adCode: "440100",
    glng: 113.264423,
    hotCity: true,
    glat: 23.129075,
  },
  {
    cityId: 21,
    cityName: "青岛",
    cityEnName: "qingdao",
    cityAbbrCode: "qd",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370200",
    glng: 120.382771,
    hotCity: true,
    glat: 36.066348,
  },
  {
    cityId: 17,
    cityName: "西安",
    cityEnName: "xian",
    cityAbbrCode: "xa",
    provinceId: 27,
    status: 3,
    regionCityId: 17,
    adCode: "610100",
    glng: 108.944265,
    hotCity: true,
    glat: 34.26488,
  },
  {
    cityId: 12,
    cityName: "扬州",
    cityEnName: "yangzhou",
    cityAbbrCode: "yz",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "321000",
    glng: 119.412854,
    hotCity: false,
    glat: 32.394237,
  },
  {
    cityId: 13,
    cityName: "无锡",
    cityEnName: "wuxi",
    cityAbbrCode: "wx",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320200",
    glng: 120.303027,
    hotCity: false,
    glat: 31.566148,
  },
  {
    cityId: 14,
    cityName: "福州",
    cityEnName: "fuzhou",
    cityAbbrCode: "fz",
    provinceId: 13,
    status: 3,
    regionCityId: 14,
    adCode: "350100",
    glng: 119.296579,
    hotCity: false,
    glat: 26.074286,
  },
  {
    cityId: 160,
    cityName: "郑州",
    cityEnName: "zhengzhou",
    cityAbbrCode: "zz11",
    provinceId: 16,
    status: 3,
    regionCityId: 160,
    adCode: "410100",
    glng: 113.624863,
    hotCity: true,
    glat: 34.747285,
  },
  {
    cityId: 208,
    cityName: "佛山",
    cityEnName: "foshan",
    cityAbbrCode: "fs5",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440600",
    glng: 113.121316,
    hotCity: true,
    glat: 23.021721,
  },
  {
    cityId: 110,
    cityName: "合肥",
    cityEnName: "hefei",
    cityAbbrCode: "hf",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340100",
    glng: 117.286983,
    hotCity: true,
    glat: 31.865779,
  },
  {
    cityId: 22,
    cityName: "济南",
    cityEnName: "jinan",
    cityAbbrCode: "jn",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370100",
    glng: 116.994915,
    hotCity: true,
    glat: 36.665282,
  },
  {
    cityId: 19,
    cityName: "大连",
    cityEnName: "dalian",
    cityAbbrCode: "dl",
    provinceId: 6,
    status: 1,
    regionCityId: 18,
    adCode: "210200",
    glng: 121.614771,
    hotCity: false,
    glat: 38.913779,
  },
  {
    cityId: 15,
    cityName: "厦门",
    cityEnName: "xiamen",
    cityAbbrCode: "xm",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350200",
    glng: 118.08939,
    hotCity: true,
    glat: 24.479615,
  },
  {
    cityId: 70,
    cityName: "长春",
    cityEnName: "changchun",
    cityAbbrCode: "cc",
    provinceId: 7,
    status: 1,
    regionCityId: 2,
    adCode: "220100",
    glng: 125.3245,
    hotCity: false,
    glat: 43.886841,
  },
  {
    cityId: 134,
    cityName: "南昌",
    cityEnName: "nanchang",
    cityAbbrCode: "nc",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360100",
    glng: 115.892151,
    hotCity: false,
    glat: 28.676493,
  },
  {
    cityId: 11,
    cityName: "宁波",
    cityEnName: "ningbo",
    cityAbbrCode: "nb",
    provinceId: 11,
    status: 3,
    regionCityId: 11,
    adCode: "330200",
    glng: 121.54399,
    hotCity: true,
    glat: 29.868336,
  },
  {
    cityId: 79,
    cityName: "哈尔滨",
    cityEnName: "haerbin",
    cityAbbrCode: "hb",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "230100",
    glng: 126.642464,
    hotCity: false,
    glat: 45.756967,
  },
  {
    cityId: 6,
    cityName: "苏州",
    cityEnName: "suzhou",
    cityAbbrCode: "suz",
    provinceId: 10,
    status: 3,
    regionCityId: 6,
    adCode: "320500",
    glng: 120.585586,
    hotCity: true,
    glat: 31.297779,
  },
  {
    cityId: 10,
    cityName: "天津",
    cityEnName: "tianjin",
    cityAbbrCode: "tj",
    provinceId: 2,
    status: 3,
    regionCityId: 2,
    adCode: "120100",
    glng: 117.21503,
    hotCity: true,
    glat: 39.120876,
  },
  {
    cityId: 345,
    cityName: "三亚",
    cityEnName: "sanya",
    cityAbbrCode: "sy13",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "460200",
    glng: 109.511909,
    hotCity: false,
    glat: 18.252847,
  },
  {
    cityId: 206,
    cityName: "珠海",
    cityEnName: "zhuhai",
    cityAbbrCode: "zh",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440400",
    glng: 113.577261,
    hotCity: false,
    glat: 22.27094,
  },
  {
    cityId: 18,
    cityName: "沈阳",
    cityEnName: "shenyang",
    cityAbbrCode: "sy",
    provinceId: 6,
    status: 3,
    regionCityId: 18,
    adCode: "210100",
    glng: 123.43045,
    hotCity: true,
    glat: 41.807321,
  },
  {
    cityId: 267,
    cityName: "昆明",
    cityEnName: "kunming",
    cityAbbrCode: "km",
    provinceId: 25,
    status: 3,
    regionCityId: 267,
    adCode: "530100",
    glng: 102.722125,
    hotCity: false,
    glat: 25.037283,
  },
  {
    cityId: 344,
    cityName: "长沙",
    cityEnName: "changsha",
    cityAbbrCode: "cs",
    provinceId: 18,
    status: 3,
    regionCityId: 344,
    adCode: "430100",
    glng: 112.938827,
    hotCity: true,
    glat: 28.228528,
  },
  {
    cityId: 35,
    cityName: "太原",
    cityEnName: "taiyuan",
    cityAbbrCode: "ty",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140100",
    glng: 112.550737,
    hotCity: false,
    glat: 37.870554,
  },
  {
    cityId: 299,
    cityName: "兰州",
    cityEnName: "lanzhou",
    cityAbbrCode: "lz5",
    provinceId: 28,
    status: 1,
    regionCityId: 17,
    adCode: "620100",
    glng: 103.834377,
    hotCity: false,
    glat: 36.061255,
  },
  {
    cityId: 219,
    cityName: "东莞",
    cityEnName: "dongguan",
    cityAbbrCode: "dg",
    provinceId: 19,
    status: 3,
    regionCityId: 219,
    adCode: "441900",
    glng: 113.751766,
    hotCity: false,
    glat: 23.020536,
  },
  {
    cityId: 341,
    cityName: "中国香港",
    cityEnName: "hongkong",
    cityAbbrCode: "hk3",
    provinceId: 32,
    status: 3,
    regionCityId: 341,
    glng: 114.172754,
    hotCity: true,
    glat: 22.282346,
  },
  {
    cityId: 24,
    cityName: "石家庄",
    cityEnName: "shijiazhuang",
    cityAbbrCode: "sjz",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130100",
    glng: 114.514864,
    hotCity: false,
    glat: 38.04232,
  },
  {
    cityId: 258,
    cityName: "贵阳",
    cityEnName: "guiyang",
    cityAbbrCode: "gy1",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "520100",
    glng: 106.713478,
    hotCity: false,
    glat: 26.578343,
  },
  {
    cityId: 224,
    cityName: "南宁",
    cityEnName: "nanning",
    cityAbbrCode: "nn",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450100",
    glng: 108.365546,
    hotCity: false,
    glat: 22.818012,
  },
  {
    cityId: 313,
    cityName: "西宁",
    cityEnName: "xining",
    cityAbbrCode: "xn3",
    provinceId: 29,
    status: 1,
    regionCityId: 2,
    adCode: "630100",
    glng: 101.778208,
    hotCity: false,
    glat: 36.61708500000001,
  },
  {
    cityId: 23,
    cityName: "海口",
    cityEnName: "haikou",
    cityAbbrCode: "hk",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "460100",
    glng: 110.328873,
    hotCity: false,
    glat: 20.030765,
  },
  {
    cityId: 325,
    cityName: "乌鲁木齐",
    cityEnName: "wulumuqi",
    cityAbbrCode: "wlm",
    provinceId: 31,
    status: 1,
    regionCityId: 17,
    adCode: "650100",
    glng: 87.617298,
    hotCity: false,
    glat: 43.825666,
  },
  {
    cityId: 46,
    cityName: "呼和浩特",
    cityEnName: "huhehaote",
    cityAbbrCode: "hh",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150100",
    glng: 111.748847,
    hotCity: false,
    glat: 40.84231,
  },
  {
    cityId: 342,
    cityName: "中国澳门",
    cityEnName: "macau",
    cityAbbrCode: "am",
    provinceId: 33,
    status: 1,
    regionCityId: 7,
    glng: 113.543873,
    hotCity: true,
    glat: 22.198745,
  },
  {
    cityId: 3206,
    cityName: "神户",
    cityEnName: "kobe",
    cityAbbrCode: "kob",
    provinceId: 105,
    status: 1,
    regionCityId: 1,
    glng: 135.141948,
    hotCity: false,
    glat: 34.743261,
  },
  {
    cityId: 3208,
    cityName: "千叶",
    cityEnName: "chiba",
    cityAbbrCode: "chb",
    provinceId: 105,
    status: 1,
    regionCityId: 1,
    glng: 140.097762,
    hotCity: false,
    glat: 35.600034,
  },
  {
    cityId: 3258,
    cityName: "俄罗斯",
    cityEnName: "russia",
    cityAbbrCode: "rus",
    provinceId: 162,
    status: 1,
    regionCityId: 17,
    glng: 105.636719,
    hotCity: false,
    glat: 62.428794,
  },
  {
    cityId: 3265,
    cityName: "保加利亚",
    cityEnName: "bulgarian",
    cityAbbrCode: "bgr",
    provinceId: 175,
    status: 1,
    regionCityId: 344,
    glng: 25.395413,
    hotCity: false,
    glat: 42.824128,
  },
  {
    cityId: 3301,
    cityName: "加拿大",
    cityEnName: "canada",
    cityAbbrCode: "can1",
    provinceId: 123,
    status: 1,
    regionCityId: 1,
    glng: -106.371093,
    hotCity: false,
    glat: 57.280608,
  },
  {
    cityId: 4226,
    cityName: "俄克拉何马城",
    cityEnName: "oklahomacity",
    cityAbbrCode: "ekl",
    provinceId: 118,
    status: 1,
    regionCityId: 1,
    glng: -97.532756,
    hotCity: false,
    glat: 35.482089,
  },
  {
    cityId: 4426,
    cityName: "万州区",
    cityEnName: "wanzhou",
    cityAbbrCode: "wz1",
    provinceId: 22,
    status: 1,
    regionCityId: 9,
    adCode: "500100",
    glng: 108.3928495595,
    hotCity: false,
    glat: 30.6957822791,
  },
  {
    cityId: 207,
    cityName: "汕头",
    cityEnName: "shantou",
    cityAbbrCode: "st",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440500",
    glng: 116.681943,
    hotCity: false,
    glat: 23.353362,
  },
  {
    cityId: 93,
    cityName: "常州",
    cityEnName: "changzhou",
    cityAbbrCode: "cz5",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320400",
    glng: 119.974454,
    hotCity: false,
    glat: 31.810077,
  },
  {
    cityId: 102,
    cityName: "嘉兴",
    cityEnName: "jiaxing",
    cityAbbrCode: "jx12",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330400",
    glng: 120.758543,
    hotCity: false,
    glat: 30.753924,
  },
  {
    cityId: 20,
    cityName: "其它城市",
    cityEnName: "more",
    cityAbbrCode: "qt",
    provinceId: 0,
    status: 1,
    regionCityId: 1,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 92,
    cityName: "徐州",
    cityEnName: "xuzhou",
    cityAbbrCode: "xz5",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320300",
    glng: 117.19108,
    hotCity: false,
    glat: 34.259827,
  },
  {
    cityId: 101,
    cityName: "温州",
    cityEnName: "wenzhou",
    cityAbbrCode: "wz",
    provinceId: 11,
    status: 1,
    regionCityId: 11,
    adCode: "330300",
    glng: 120.699355,
    hotCity: false,
    glat: 27.994243,
  },
  {
    cityId: 226,
    cityName: "桂林",
    cityEnName: "guilin",
    cityAbbrCode: "gl",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450300",
    glng: 110.290195,
    hotCity: false,
    glat: 25.273567,
  },
  {
    cityId: 29,
    cityName: "保定",
    cityEnName: "baoding",
    cityAbbrCode: "bd",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130600",
    glng: 115.46463,
    hotCity: false,
    glat: 38.873972,
  },
  {
    cityId: 108,
    cityName: "台州",
    cityEnName: "zhejiangtaizhou",
    cityAbbrCode: "tz2",
    provinceId: 11,
    status: 1,
    regionCityId: 11,
    adCode: "331000",
    glng: 121.175834,
    hotCity: false,
    glat: 28.828501,
  },
  {
    cityId: 148,
    cityName: "烟台",
    cityEnName: "yantai",
    cityAbbrCode: "yt6",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370600",
    glng: 121.391382,
    hotCity: false,
    glat: 37.539297,
  },
  {
    cityId: 105,
    cityName: "金华",
    cityEnName: "jinhua",
    cityAbbrCode: "jh",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330700",
    glng: 119.647422,
    hotCity: false,
    glat: 29.079164,
  },
  {
    cityId: 104,
    cityName: "绍兴",
    cityEnName: "shaoxing",
    cityAbbrCode: "sx",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330600",
    glng: 120.586109,
    hotCity: false,
    glat: 29.995762,
  },
  {
    cityId: 209,
    cityName: "江门",
    cityEnName: "jiangmen",
    cityAbbrCode: "jm1",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440700",
    glng: 113.08187,
    hotCity: false,
    glat: 22.57877,
  },
  {
    cityId: 129,
    cityName: "泉州",
    cityEnName: "quanzhou",
    cityAbbrCode: "qz3",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350500",
    glng: 118.587114,
    hotCity: false,
    glat: 24.907398,
  },
  {
    cityId: 279,
    cityName: "丽江",
    cityEnName: "lijiang",
    cityAbbrCode: "lj",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "530700",
    glng: 100.230376,
    hotCity: false,
    glat: 26.876774,
  },
  {
    cityId: 94,
    cityName: "南通",
    cityEnName: "nantong",
    cityAbbrCode: "nt",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320600",
    glng: 120.894324,
    hotCity: false,
    glat: 31.979997,
  },
  {
    cityId: 220,
    cityName: "中山",
    cityEnName: "zhongshan",
    cityAbbrCode: "zs6",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "442000",
    glng: 113.392756,
    hotCity: false,
    glat: 22.516481,
  },
  {
    cityId: 26,
    cityName: "秦皇岛",
    cityEnName: "qinhuangdao",
    cityAbbrCode: "qhd",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130300",
    glng: 119.600492,
    hotCity: false,
    glat: 39.935377,
  },
  {
    cityId: 71,
    cityName: "吉林",
    cityEnName: "jilin",
    cityAbbrCode: "jl",
    provinceId: 7,
    status: 1,
    regionCityId: 2,
    adCode: "220200",
    glng: 126.549572,
    hotCity: false,
    glat: 43.837883,
  },
  {
    cityId: 36,
    cityName: "大同",
    cityEnName: "datong",
    cityAbbrCode: "dt",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140200",
    glng: 113.300126,
    hotCity: false,
    glat: 40.076816,
  },
  {
    cityId: 152,
    cityName: "威海",
    cityEnName: "weihai",
    cityAbbrCode: "wh6",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371000",
    glng: 122.12042,
    hotCity: false,
    glat: 37.513068,
  },
  {
    cityId: 27,
    cityName: "邯郸",
    cityEnName: "handan",
    cityAbbrCode: "hd",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130400",
    glng: 114.492968,
    hotCity: false,
    glat: 36.612267,
  },
  {
    cityId: 103,
    cityName: "湖州",
    cityEnName: "huzhou",
    cityAbbrCode: "hz14",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330500",
    glng: 120.08681800000001,
    hotCity: false,
    glat: 30.89436,
  },
  {
    cityId: 179,
    cityName: "宜昌",
    cityEnName: "yichang",
    cityAbbrCode: "yc16",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420500",
    glng: 111.286471,
    hotCity: false,
    glat: 30.691967,
  },
  {
    cityId: 321,
    cityName: "银川",
    cityEnName: "yinchuan",
    cityAbbrCode: "yc20",
    provinceId: 30,
    status: 1,
    regionCityId: 17,
    adCode: "640100",
    glng: 106.230909,
    hotCity: false,
    glat: 38.487194,
  },
  {
    cityId: 33,
    cityName: "廊坊",
    cityEnName: "langfang",
    cityAbbrCode: "lf",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "131000",
    glng: 116.706651,
    hotCity: false,
    glat: 39.521017,
  },
  {
    cityId: 166,
    cityName: "新乡",
    cityEnName: "xinxiang",
    cityAbbrCode: "xx",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "410700",
    glng: 113.926924,
    hotCity: false,
    glat: 35.303318,
  },
  {
    cityId: 211,
    cityName: "茂名",
    cityEnName: "maoming",
    cityAbbrCode: "mm",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440900",
    glng: 110.925467,
    hotCity: false,
    glat: 21.662956,
  },
  {
    cityId: 107,
    cityName: "舟山",
    cityEnName: "zhoushan",
    cityAbbrCode: "zs",
    provinceId: 11,
    status: 1,
    regionCityId: 11,
    adCode: "330900",
    glng: 122.206596,
    hotCity: false,
    glat: 29.985444,
  },
  {
    cityId: 217,
    cityName: "阳江",
    cityEnName: "yangjiang",
    cityAbbrCode: "yj",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441700",
    glng: 111.982536,
    hotCity: false,
    glat: 21.857662,
  },
  {
    cityId: 98,
    cityName: "镇江",
    cityEnName: "zhenjiang",
    cityAbbrCode: "zj",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "321100",
    glng: 119.456928,
    hotCity: false,
    glat: 32.199789,
  },
  {
    cityId: 25,
    cityName: "唐山",
    cityEnName: "tangshan",
    cityAbbrCode: "ts",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130200",
    glng: 118.180407,
    hotCity: false,
    glat: 39.630476,
  },
  {
    cityId: 149,
    cityName: "潍坊",
    cityEnName: "weifang",
    cityAbbrCode: "wf",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370700",
    glng: 119.161929,
    hotCity: false,
    glat: 36.706824,
  },
  {
    cityId: 162,
    cityName: "洛阳",
    cityEnName: "luoyang",
    cityAbbrCode: "ly3",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "410300",
    glng: 112.454363,
    hotCity: false,
    glat: 34.618154,
  },
  {
    cityId: 58,
    cityName: "鞍山",
    cityEnName: "anshan",
    cityAbbrCode: "as",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210300",
    glng: 122.994646,
    hotCity: false,
    glat: 41.108546,
  },
  {
    cityId: 84,
    cityName: "大庆",
    cityEnName: "daqing",
    cityAbbrCode: "dq",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "230600",
    glng: 125.104637,
    hotCity: false,
    glat: 46.59019,
  },
  {
    cityId: 118,
    cityName: "黄山",
    cityEnName: "huangshan",
    cityAbbrCode: "hs7",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "341000",
    glng: 118.1698,
    hotCity: false,
    glat: 30.113961,
  },
  {
    cityId: 212,
    cityName: "肇庆",
    cityEnName: "zhaoqing",
    cityAbbrCode: "zq",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441200",
    glng: 112.465166,
    hotCity: false,
    glat: 23.047596,
  },
  {
    cityId: 213,
    cityName: "惠州",
    cityEnName: "huizhou",
    cityAbbrCode: "hz5",
    provinceId: 19,
    status: 1,
    regionCityId: 7,
    adCode: "441300",
    glng: 114.412599,
    hotCity: false,
    glat: 23.079404,
  },
  {
    cityId: 28,
    cityName: "邢台",
    cityEnName: "xingtai",
    cityAbbrCode: "xt",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130500",
    glng: 114.504874,
    hotCity: false,
    glat: 37.070589,
  },
  {
    cityId: 151,
    cityName: "泰安",
    cityEnName: "taian",
    cityAbbrCode: "ta",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370900",
    glng: 117.088115,
    hotCity: false,
    glat: 36.20002,
  },
  {
    cityId: 238,
    cityName: "自贡",
    cityEnName: "zigong",
    cityAbbrCode: "zg",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510300",
    glng: 104.778564,
    hotCity: false,
    glat: 29.338978,
  },
  {
    cityId: 96,
    cityName: "淮安",
    cityEnName: "huaian",
    cityAbbrCode: "ha",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320800",
    glng: 119.015755,
    hotCity: false,
    glat: 33.611084,
  },
  {
    cityId: 145,
    cityName: "淄博",
    cityEnName: "zibo",
    cityAbbrCode: "zb",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370300",
    glng: 118.055007,
    hotCity: false,
    glat: 36.813497,
  },
  {
    cityId: 210,
    cityName: "湛江",
    cityEnName: "zhanjiang",
    cityAbbrCode: "zj3",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440800",
    glng: 110.359255,
    hotCity: false,
    glat: 21.270764,
  },
  {
    cityId: 205,
    cityName: "韶关",
    cityEnName: "shaoguan",
    cityAbbrCode: "sg",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440200",
    glng: 113.597299,
    hotCity: false,
    glat: 24.811098,
  },
  {
    cityId: 291,
    cityName: "宝鸡",
    cityEnName: "baoji",
    cityAbbrCode: "bj1",
    provinceId: 27,
    status: 1,
    regionCityId: 17,
    adCode: "610300",
    glng: 107.133785,
    hotCity: false,
    glat: 34.372529,
  },
  {
    cityId: 140,
    cityName: "赣州",
    cityEnName: "ganzhou",
    cityAbbrCode: "gz2",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360700",
    glng: 114.933553,
    hotCity: false,
    glat: 25.829209,
  },
  {
    cityId: 246,
    cityName: "乐山",
    cityEnName: "leshan",
    cityAbbrCode: "ls27",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511100",
    glng: 103.765623,
    hotCity: false,
    glat: 29.552064,
  },
  {
    cityId: 137,
    cityName: "九江",
    cityEnName: "jiujiang",
    cityAbbrCode: "jj",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360400",
    glng: 116.001982,
    hotCity: false,
    glat: 29.705096,
  },
  {
    cityId: 95,
    cityName: "连云港",
    cityEnName: "lianyuangang",
    cityAbbrCode: "lyg",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320700",
    glng: 119.178821,
    hotCity: false,
    glat: 34.600018,
  },
  {
    cityId: 225,
    cityName: "柳州",
    cityEnName: "liuzhou",
    cityAbbrCode: "lz",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450200",
    glng: 109.415577,
    hotCity: false,
    glat: 24.32551,
  },
  {
    cityId: 62,
    cityName: "锦州",
    cityEnName: "jinzhou",
    cityAbbrCode: "jz8",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210700",
    glng: 121.12700999999998,
    hotCity: false,
    glat: 41.095123,
  },
  {
    cityId: 47,
    cityName: "包头",
    cityEnName: "baotou",
    cityAbbrCode: "bt",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150200",
    glng: 109.840385,
    hotCity: false,
    glat: 40.657447,
  },
  {
    cityId: 155,
    cityName: "临沂",
    cityEnName: "linyi",
    cityAbbrCode: "ly20",
    provinceId: 15,
    status: 3,
    regionCityId: 155,
    adCode: "371300",
    glng: 118.347708,
    hotCity: false,
    glat: 35.051712,
  },
  {
    cityId: 242,
    cityName: "绵阳",
    cityEnName: "mianyang",
    cityAbbrCode: "my",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510700",
    glng: 104.741274,
    hotCity: false,
    glat: 31.463377,
  },
  {
    cityId: 99,
    cityName: "泰州",
    cityEnName: "taizhou",
    cityAbbrCode: "tz",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    glng: 119.923046,
    hotCity: false,
    glat: 32.456584,
  },
  {
    cityId: 150,
    cityName: "济宁",
    cityEnName: "jining",
    cityAbbrCode: "jn5",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370800",
    glng: 116.587075,
    hotCity: false,
    glat: 35.414865,
  },
  {
    cityId: 292,
    cityName: "咸阳",
    cityEnName: "xianyang",
    cityAbbrCode: "xy21",
    provinceId: 27,
    status: 1,
    regionCityId: 17,
    adCode: "610400",
    glng: 108.709193,
    hotCity: false,
    glat: 34.329434,
  },
  {
    cityId: 112,
    cityName: "蚌埠",
    cityEnName: "bengbu",
    cityAbbrCode: "bb",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340300",
    glng: 117.38971,
    hotCity: false,
    glat: 32.916282,
  },
  {
    cityId: 59,
    cityName: "抚顺",
    cityEnName: "fushun",
    cityAbbrCode: "fs",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210400",
    glng: 123.915237,
    hotCity: false,
    glat: 41.880701,
  },
  {
    cityId: 97,
    cityName: "盐城",
    cityEnName: "yancheng",
    cityAbbrCode: "yc8",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320900",
    glng: 120.163544,
    hotCity: false,
    glat: 33.347416,
  },
  {
    cityId: 218,
    cityName: "清远",
    cityEnName: "qingyuan",
    cityAbbrCode: "qy",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441800",
    glng: 113.056042,
    hotCity: false,
    glat: 23.681801,
  },
  {
    cityId: 63,
    cityName: "营口",
    cityEnName: "yingkou",
    cityAbbrCode: "yk",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210800",
    glng: 122.235286,
    hotCity: false,
    glat: 40.666989,
  },
  {
    cityId: 147,
    cityName: "东营",
    cityEnName: "dongying",
    cityAbbrCode: "dy",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370500",
    glng: 118.675487,
    hotCity: false,
    glat: 37.435382,
  },
  {
    cityId: 61,
    cityName: "丹东",
    cityEnName: "dandong",
    cityAbbrCode: "dd",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210600",
    glng: 124.384913,
    hotCity: false,
    glat: 40.127344,
  },
  {
    cityId: 184,
    cityName: "荆州",
    cityEnName: "jingzhou",
    cityAbbrCode: "jz12",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "421000",
    glng: 112.239741,
    hotCity: false,
    glat: 30.335165,
  },
  {
    cityId: 69,
    cityName: "葫芦岛",
    cityEnName: "huludao",
    cityAbbrCode: "hld",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "211400",
    glng: 120.836827,
    hotCity: false,
    glat: 40.710953,
  },
  {
    cityId: 153,
    cityName: "日照",
    cityEnName: "rizhao",
    cityAbbrCode: "rz",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371100",
    glng: 119.526888,
    hotCity: false,
    glat: 35.416377,
  },
  {
    cityId: 31,
    cityName: "承德",
    cityEnName: "chengde",
    cityAbbrCode: "cd2",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130800",
    glng: 117.943621,
    hotCity: false,
    glat: 40.978744,
  },
  {
    cityId: 144,
    cityName: "上饶",
    cityEnName: "shangrao",
    cityAbbrCode: "sr",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "361100",
    glng: 117.976371,
    hotCity: false,
    glat: 28.443318,
  },
  {
    cityId: 277,
    cityName: "大理州",
    cityEnName: "dali",
    cityAbbrCode: "dl4",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "532900",
    glng: 100.267638,
    hotCity: false,
    glat: 25.606486,
  },
  {
    cityId: 111,
    cityName: "芜湖",
    cityEnName: "wuhu",
    cityAbbrCode: "wh5",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340200",
    glng: 118.385156,
    hotCity: false,
    glat: 31.33879,
  },
  {
    cityId: 32,
    cityName: "沧州",
    cityEnName: "cangzhou",
    cityAbbrCode: "cz",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130900",
    glng: 116.83884,
    hotCity: false,
    glat: 38.304449,
  },
  {
    cityId: 30,
    cityName: "张家口",
    cityEnName: "zhangjiakou",
    cityAbbrCode: "zjk",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "130700",
    glng: 114.885951,
    hotCity: false,
    glat: 40.767576,
  },
  {
    cityId: 185,
    cityName: "黄冈",
    cityEnName: "huanggang",
    cityAbbrCode: "hg1",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "421100",
    glng: 114.872253,
    hotCity: false,
    glat: 30.453877,
  },
  {
    cityId: 106,
    cityName: "衢州",
    cityEnName: "quzhou",
    cityAbbrCode: "qz",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330800",
    glng: 118.874018,
    hotCity: false,
    glat: 28.935883,
  },
  {
    cityId: 169,
    cityName: "许昌",
    cityEnName: "xuchang",
    cityAbbrCode: "xc7",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "411000",
    glng: 113.85394,
    hotCity: false,
    glat: 34.035608,
  },
  {
    cityId: 214,
    cityName: "梅州",
    cityEnName: "meizhou",
    cityAbbrCode: "mz",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441400",
    glng: 116.12245,
    hotCity: false,
    glat: 24.288531,
  },
  {
    cityId: 178,
    cityName: "十堰",
    cityEnName: "shiyan",
    cityAbbrCode: "sy7",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420300",
    glng: 110.788915,
    hotCity: false,
    glat: 32.650381,
  },
  {
    cityId: 177,
    cityName: "黄石",
    cityEnName: "huangshi",
    cityAbbrCode: "hs10",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420200",
    glng: 115.03852,
    hotCity: false,
    glat: 30.199652,
  },
  {
    cityId: 164,
    cityName: "安阳",
    cityEnName: "anyang",
    cityAbbrCode: "ay",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "410500",
    glng: 114.392756,
    hotCity: false,
    glat: 36.097593,
  },
  {
    cityId: 227,
    cityName: "梧州",
    cityEnName: "wuzhou",
    cityAbbrCode: "wz2",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450400",
    glng: 111.27917,
    hotCity: false,
    glat: 23.47691,
  },
  {
    cityId: 198,
    cityName: "张家界",
    cityEnName: "zhangjiajie",
    cityAbbrCode: "zjj",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430800",
    glng: 110.479111,
    hotCity: false,
    glat: 29.116337,
  },
  {
    cityId: 194,
    cityName: "衡阳",
    cityEnName: "hengyang",
    cityAbbrCode: "hy",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430400",
    glng: 112.5719,
    hotCity: false,
    glat: 26.893839,
  },
  {
    cityId: 216,
    cityName: "河源",
    cityEnName: "heyuan",
    cityAbbrCode: "hy3",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441600",
    glng: 114.700446,
    hotCity: false,
    glat: 23.743538,
  },
  {
    cityId: 66,
    cityName: "盘锦",
    cityEnName: "panjin",
    cityAbbrCode: "pj",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "211100",
    glng: 122.070715,
    hotCity: false,
    glat: 41.119998,
  },
  {
    cityId: 180,
    cityName: "襄阳",
    cityEnName: "xiangyang",
    cityAbbrCode: "xy18",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420600",
    glng: 112.155394,
    hotCity: false,
    glat: 32.023443,
  },
  {
    cityId: 192,
    cityName: "株洲",
    cityEnName: "zhuzhou",
    cityAbbrCode: "zz2",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430200",
    glng: 113.133891,
    hotCity: false,
    glat: 27.827892,
  },
  {
    cityId: 113,
    cityName: "淮南",
    cityEnName: "huainan",
    cityAbbrCode: "hn",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340400",
    glng: 116.999958,
    hotCity: false,
    glat: 32.625397,
  },
  {
    cityId: 146,
    cityName: "枣庄",
    cityEnName: "zaozhuang",
    cityAbbrCode: "zz9",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370400",
    glng: 117.323725,
    hotCity: false,
    glat: 34.8105,
  },
  {
    cityId: 119,
    cityName: "滁州",
    cityEnName: "chuzhou",
    cityAbbrCode: "cz7",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "341100",
    glng: 118.317107,
    hotCity: false,
    glat: 32.301556,
  },
  {
    cityId: 117,
    cityName: "安庆",
    cityEnName: "anqing",
    cityAbbrCode: "aq",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340800",
    glng: 117.05673,
    hotCity: false,
    glat: 30.524961,
  },
  {
    cityId: 193,
    cityName: "湘潭",
    cityEnName: "xiangtan",
    cityAbbrCode: "xt4",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430300",
    glng: 112.907339,
    hotCity: false,
    glat: 27.856325,
  },
  {
    cityId: 114,
    cityName: "马鞍山",
    cityEnName: "maanshan",
    cityAbbrCode: "mas",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340500",
    glng: 118.504657,
    hotCity: false,
    glat: 31.696788,
  },
  {
    cityId: 228,
    cityName: "北海",
    cityEnName: "beihai",
    cityAbbrCode: "bh",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450500",
    glng: 109.119951,
    hotCity: false,
    glat: 21.481198,
  },
  {
    cityId: 195,
    cityName: "邵阳",
    cityEnName: "shaoyang",
    cityAbbrCode: "sy10",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430500",
    glng: 111.468236,
    hotCity: false,
    glat: 27.239973,
  },
  {
    cityId: 60,
    cityName: "本溪",
    cityEnName: "benxi",
    cityAbbrCode: "bx",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210500",
    glng: 123.766485,
    hotCity: false,
    glat: 41.294176,
  },
  {
    cityId: 156,
    cityName: "德州",
    cityEnName: "dezhou",
    cityAbbrCode: "dz",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371400",
    glng: 116.302587,
    hotCity: false,
    glat: 37.45092,
  },
  {
    cityId: 88,
    cityName: "牡丹江",
    cityEnName: "mudanjiang",
    cityAbbrCode: "mdj",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "231000",
    glng: 129.614665,
    hotCity: false,
    glat: 44.587633,
  },
  {
    cityId: 130,
    cityName: "漳州",
    cityEnName: "zhangzhou",
    cityAbbrCode: "zz",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350600",
    glng: 117.647363,
    hotCity: false,
    glat: 24.513321,
  },
  {
    cityId: 158,
    cityName: "滨州",
    cityEnName: "binzhou",
    cityAbbrCode: "bz1",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371600",
    glng: 117.97143,
    hotCity: false,
    glat: 37.381403,
  },
  {
    cityId: 135,
    cityName: "景德镇",
    cityEnName: "jingdezhen",
    cityAbbrCode: "jdz",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360200",
    glng: 117.181566,
    hotCity: false,
    glat: 29.307094,
  },
  {
    cityId: 196,
    cityName: "岳阳",
    cityEnName: "yueyang",
    cityAbbrCode: "yy",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430600",
    glng: 113.12887699999999,
    hotCity: false,
    glat: 29.356983,
  },
  {
    cityId: 157,
    cityName: "聊城",
    cityEnName: "liaocheng",
    cityAbbrCode: "lc",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371500",
    glng: 115.985371,
    hotCity: false,
    glat: 36.456696,
  },
  {
    cityId: 172,
    cityName: "南阳",
    cityEnName: "nanyang",
    cityAbbrCode: "ny",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "411300",
    glng: 112.528345,
    hotCity: false,
    glat: 32.990615,
  },
  {
    cityId: 133,
    cityName: "宁德",
    cityEnName: "ningde",
    cityAbbrCode: "nd",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350900",
    glng: 119.526287,
    hotCity: false,
    glat: 26.666291,
  },
  {
    cityId: 260,
    cityName: "遵义",
    cityEnName: "zunyi",
    cityAbbrCode: "zy5",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "520300",
    glng: 106.927389,
    hotCity: false,
    glat: 27.725654,
  },
  {
    cityId: 234,
    cityName: "贺州",
    cityEnName: "hezhou",
    cityAbbrCode: "hz7",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "451100",
    glng: 111.566753,
    hotCity: false,
    glat: 24.40357,
  },
  {
    cityId: 64,
    cityName: "阜新",
    cityEnName: "fuxin",
    cityAbbrCode: "fx",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210900",
    glng: 121.670326,
    hotCity: false,
    glat: 42.02162,
  },
  {
    cityId: 222,
    cityName: "揭阳",
    cityEnName: "jieyang",
    cityAbbrCode: "jy",
    provinceId: 19,
    status: 1,
    regionCityId: 7,
    adCode: "445200",
    glng: 116.37283,
    hotCity: false,
    glat: 23.549994,
  },
  {
    cityId: 86,
    cityName: "佳木斯",
    cityEnName: "jiamusi",
    cityAbbrCode: "jms",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "230800",
    glng: 130.318917,
    hotCity: false,
    glat: 46.799923,
  },
  {
    cityId: 247,
    cityName: "南充",
    cityEnName: "nanchong",
    cityAbbrCode: "nc1",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511300",
    glng: 106.110595,
    hotCity: false,
    glat: 30.837888,
  },
  {
    cityId: 293,
    cityName: "渭南",
    cityEnName: "weinan",
    cityAbbrCode: "wn",
    provinceId: 27,
    status: 1,
    regionCityId: 17,
    adCode: "610500",
    glng: 109.509786,
    hotCity: false,
    glat: 34.499995,
  },
  {
    cityId: 127,
    cityName: "莆田",
    cityEnName: "putian",
    cityAbbrCode: "pt",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350300",
    glng: 119.007558,
    hotCity: false,
    glat: 25.431011,
  },
  {
    cityId: 41,
    cityName: "晋中",
    cityEnName: "jinzhong",
    cityAbbrCode: "jz",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140700",
    glng: 112.752636,
    hotCity: false,
    glat: 37.687204,
  },
  {
    cityId: 182,
    cityName: "荆门",
    cityEnName: "jinmen",
    cityAbbrCode: "jm",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420800",
    glng: 112.199265,
    hotCity: false,
    glat: 31.035423,
  },
  {
    cityId: 167,
    cityName: "焦作",
    cityEnName: "jiaozuo",
    cityAbbrCode: "jz10",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "410800",
    glng: 113.242058,
    hotCity: false,
    glat: 35.215371,
  },
  {
    cityId: 221,
    cityName: "潮州",
    cityEnName: "chaozhou",
    cityAbbrCode: "cz1",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "445100",
    glng: 116.623417,
    hotCity: false,
    glat: 23.656722,
  },
  {
    cityId: 163,
    cityName: "平顶山",
    cityEnName: "pingdingshan",
    cityAbbrCode: "pds",
    provinceId: 16,
    status: 1,
    regionCityId: 160,
    adCode: "410400",
    glng: 113.307006,
    hotCity: false,
    glat: 33.745244,
  },
  {
    cityId: 67,
    cityName: "铁岭",
    cityEnName: "tieling",
    cityAbbrCode: "tl3",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "211200",
    glng: 123.842352,
    hotCity: false,
    glat: 42.286287,
  },
  {
    cityId: 120,
    cityName: "阜阳",
    cityEnName: "fuyang",
    cityAbbrCode: "fy",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "341200",
    glng: 115.814144,
    hotCity: false,
    glat: 32.890124,
  },
  {
    cityId: 255,
    cityName: "阿坝",
    cityEnName: "aba",
    cityAbbrCode: "ab",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    glng: 102.224653,
    hotCity: false,
    glat: 31.899413,
  },
  {
    cityId: 296,
    cityName: "榆林",
    cityEnName: "yulin",
    cityAbbrCode: "yl4",
    provinceId: 27,
    status: 1,
    regionCityId: 17,
    adCode: "610800",
    glng: 109.735209,
    hotCity: false,
    glat: 38.285526,
  },
  {
    cityId: 265,
    cityName: "黔东南",
    cityEnName: "qiandongnan",
    cityAbbrCode: "qdn",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "522600",
    glng: 107.982828,
    hotCity: false,
    glat: 26.58355,
  },
  {
    cityId: 249,
    cityName: "宜宾",
    cityEnName: "yibin",
    cityAbbrCode: "yb1",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511500",
    glng: 104.643418,
    hotCity: false,
    glat: 28.751853,
  },
  {
    cityId: 141,
    cityName: "吉安",
    cityEnName: "jian",
    cityAbbrCode: "ja",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360800",
    glng: 114.993097,
    hotCity: false,
    glat: 27.113165,
  },
  {
    cityId: 109,
    cityName: "丽水",
    cityEnName: "lishui",
    cityAbbrCode: "ls",
    provinceId: 11,
    status: 1,
    regionCityId: 11,
    adCode: "331100",
    glng: 119.916875,
    hotCity: false,
    glat: 28.451695,
  },
  {
    cityId: 100,
    cityName: "宿迁",
    cityEnName: "suqian",
    cityAbbrCode: "sq",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "321300",
    glng: 118.275289,
    hotCity: false,
    glat: 33.962083,
  },
  {
    cityId: 52,
    cityName: "呼伦贝尔",
    cityEnName: "hulunbeier",
    cityAbbrCode: "hl",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150700",
    glng: 119.765739,
    hotCity: false,
    glat: 49.211572,
  },
  {
    cityId: 159,
    cityName: "菏泽",
    cityEnName: "heze",
    cityAbbrCode: "hz2",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371700",
    glng: 115.480656,
    hotCity: false,
    glat: 35.23375,
  },
  {
    cityId: 138,
    cityName: "新余",
    cityEnName: "xinyu",
    cityAbbrCode: "xy",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360500",
    glng: 114.91741,
    hotCity: false,
    glat: 27.817823,
  },
  {
    cityId: 307,
    cityName: "酒泉",
    cityEnName: "jiuquan",
    cityAbbrCode: "jq",
    provinceId: 28,
    status: 1,
    regionCityId: 17,
    adCode: "620900",
    glng: 98.494411,
    hotCity: false,
    glat: 39.732488,
  },
  {
    cityId: 215,
    cityName: "汕尾",
    cityEnName: "shanwei",
    cityAbbrCode: "sw",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441500",
    glng: 115.375061,
    hotCity: false,
    glat: 22.785625,
  },
  {
    cityId: 173,
    cityName: "商丘",
    cityEnName: "shangqiu",
    cityAbbrCode: "sq1",
    provinceId: 16,
    status: 3,
    regionCityId: 160,
    adCode: "411400",
    glng: 115.656394,
    hotCity: false,
    glat: 34.414183,
  },
  {
    cityId: 49,
    cityName: "赤峰",
    cityEnName: "chifeng",
    cityAbbrCode: "cf",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150400",
    glng: 118.886856,
    hotCity: false,
    glat: 42.257817,
  },
  {
    cityId: 186,
    cityName: "咸宁",
    cityEnName: "xianning",
    cityAbbrCode: "xn",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "421200",
    glng: 114.322501,
    hotCity: false,
    glat: 29.841447,
  },
  {
    cityId: 261,
    cityName: "安顺",
    cityEnName: "anshun",
    cityAbbrCode: "as3",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "520400",
    glng: 105.947594,
    hotCity: false,
    glat: 26.253072,
  },
  {
    cityId: 223,
    cityName: "云浮",
    cityEnName: "yunfu",
    cityAbbrCode: "yf",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "445300",
    glng: 112.044335,
    hotCity: false,
    glat: 22.914989,
  },
  {
    cityId: 241,
    cityName: "德阳",
    cityEnName: "deyang",
    cityAbbrCode: "dy4",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510600",
    glng: 104.397808,
    hotCity: false,
    glat: 31.127537,
  },
  {
    cityId: 124,
    cityName: "亳州",
    cityEnName: "bozhou",
    cityAbbrCode: "bz",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "341600",
    glng: 115.778676,
    hotCity: false,
    glat: 33.844582,
  },
  {
    cityId: 190,
    cityName: "潜江",
    cityEnName: "qianjiang",
    cityAbbrCode: "qj",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "429005",
    glng: 112.900078,
    hotCity: false,
    glat: 30.40211,
  },
  {
    cityId: 51,
    cityName: "鄂尔多斯",
    cityEnName: "eerduosi",
    cityAbbrCode: "ee",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150600",
    glng: 109.781202,
    hotCity: false,
    glat: 39.608182,
  },
  {
    cityId: 231,
    cityName: "贵港",
    cityEnName: "guigang",
    cityAbbrCode: "gg",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450800",
    glng: 109.598927,
    hotCity: false,
    glat: 23.111531,
  },
  {
    cityId: 252,
    cityName: "雅安",
    cityEnName: "yaan",
    cityAbbrCode: "ya",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511800",
    glng: 103.013163,
    hotCity: false,
    glat: 29.980514,
  },
  {
    cityId: 230,
    cityName: "钦州",
    cityEnName: "qinzhou",
    cityAbbrCode: "qz4",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450700",
    glng: 108.654543,
    hotCity: false,
    glat: 21.980968,
  },
  {
    cityId: 199,
    cityName: "益阳",
    cityEnName: "yiyang",
    cityAbbrCode: "yy8",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "430900",
    glng: 112.355338,
    hotCity: false,
    glat: 28.580483,
  },
  {
    cityId: 257,
    cityName: "凉山",
    cityEnName: "liangshan",
    cityAbbrCode: "ls5",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "513400",
    glng: 102.267726,
    hotCity: false,
    glat: 27.881429,
  },
  {
    cityId: 244,
    cityName: "遂宁",
    cityEnName: "suining",
    cityAbbrCode: "sn",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510900",
    glng: 105.568187,
    hotCity: false,
    glat: 30.52548,
  },
  {
    cityId: 245,
    cityName: "内江",
    cityEnName: "neijiang",
    cityAbbrCode: "nj4",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511000",
    glng: 105.0583,
    hotCity: false,
    glat: 29.580237,
  },
  {
    cityId: 276,
    cityName: "西双版纳",
    cityEnName: "xishuangbanna",
    cityAbbrCode: "xsb",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "532800",
    glng: 100.797283,
    hotCity: false,
    glat: 22.008178,
  },
  {
    cityId: 154,
    cityName: "莱芜",
    cityEnName: "laiwu",
    cityAbbrCode: "lw",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "371200",
    glng: 117.676731,
    hotCity: false,
    glat: 36.213691,
  },
  {
    cityId: 202,
    cityName: "怀化",
    cityEnName: "huaihua",
    cityAbbrCode: "hh2",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "431200",
    glng: 109.99848799999998,
    hotCity: false,
    glat: 27.554978,
  },
  {
    cityId: 240,
    cityName: "泸州",
    cityEnName: "luzhou",
    cityAbbrCode: "lz19",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510500",
    glng: 105.442141,
    hotCity: false,
    glat: 28.87176,
  },
  {
    cityId: 74,
    cityName: "通化",
    cityEnName: "tonghua",
    cityAbbrCode: "th",
    provinceId: 7,
    status: 1,
    regionCityId: 2,
    adCode: "220500",
    glng: 125.939697,
    hotCity: false,
    glat: 41.728401,
  },
  {
    cityId: 38,
    cityName: "长治",
    cityEnName: "changzhi",
    cityAbbrCode: "cz3",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140400",
    glng: 113.116255,
    hotCity: false,
    glat: 36.195386,
  },
  {
    cityId: 183,
    cityName: "孝感",
    cityEnName: "xiaogan",
    cityAbbrCode: "xg",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "420900",
    glng: 113.9169,
    hotCity: false,
    glat: 30.924572,
  },
  {
    cityId: 251,
    cityName: "达州",
    cityEnName: "dazhou",
    cityAbbrCode: "dz2",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511700",
    glng: 107.468023,
    hotCity: false,
    glat: 31.209572,
  },
  {
    cityId: 34,
    cityName: "衡水",
    cityEnName: "hengshui",
    cityAbbrCode: "hs",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "131100",
    glng: 115.69868,
    hotCity: false,
    glat: 37.735302,
  },
  {
    cityId: 142,
    cityName: "宜春",
    cityEnName: "jiangxiyichun",
    cityAbbrCode: "yc12",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360900",
    glng: 114.395108,
    hotCity: false,
    glat: 27.796561,
  },
  {
    cityId: 116,
    cityName: "铜陵",
    cityEnName: "tongling",
    cityAbbrCode: "tl5",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    glng: 117.810841,
    hotCity: false,
    glat: 30.94453,
  },
  {
    cityId: 136,
    cityName: "萍乡",
    cityEnName: "pingxiang",
    cityAbbrCode: "px",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360300",
    glng: 113.854676,
    hotCity: false,
    glat: 27.622865,
  },
  {
    cityId: 139,
    cityName: "鹰潭",
    cityEnName: "yingtan",
    cityAbbrCode: "yt",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "360600",
    glng: 117.069202,
    hotCity: false,
    glat: 28.260189,
  },
  {
    cityId: 50,
    cityName: "通辽",
    cityEnName: "tongliao",
    cityAbbrCode: "tl",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150500",
    glng: 122.265737,
    hotCity: false,
    glat: 43.61944,
  },
  {
    cityId: 188,
    cityName: "恩施",
    cityEnName: "enshizhou",
    cityAbbrCode: "esz",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "422800",
    glng: 109.488162,
    hotCity: false,
    glat: 30.272204,
  },
  {
    cityId: 232,
    cityName: "玉林",
    cityEnName: "guangxiyulin",
    cityAbbrCode: "yl",
    provinceId: 20,
    status: 1,
    regionCityId: 4,
    adCode: "450900",
    glng: 110.164756,
    hotCity: false,
    glat: 22.636379,
  },
  {
    cityId: 143,
    cityName: "抚州",
    cityEnName: "jiangxifuzhou",
    cityAbbrCode: "fz4",
    provinceId: 14,
    status: 1,
    regionCityId: 344,
    adCode: "361000",
    glng: 116.358378,
    hotCity: false,
    glat: 27.992296,
  },
  {
    cityId: 200,
    cityName: "郴州",
    cityEnName: "chenzhou",
    cityAbbrCode: "cz9",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "431000",
    glng: 113.014718,
    hotCity: false,
    glat: 25.77051,
  },
  {
    cityId: 43,
    cityName: "忻州",
    cityEnName: "xinzhou",
    cityAbbrCode: "xz",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140900",
    glng: 112.734269,
    hotCity: false,
    glat: 38.416364,
  },
  {
    cityId: 303,
    cityName: "天水",
    cityEnName: "tianshui",
    cityAbbrCode: "ts4",
    provinceId: 28,
    status: 1,
    regionCityId: 17,
    adCode: "620500",
    glng: 105.724947,
    hotCity: false,
    glat: 34.580862,
  },
  {
    cityId: 256,
    cityName: "甘孜州",
    cityEnName: "ganzi",
    cityAbbrCode: "gz4",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    glng: 101.962311,
    hotCity: false,
    glat: 30.049519999999998,
  },
  {
    cityId: 297,
    cityName: "安康",
    cityEnName: "ankang",
    cityAbbrCode: "ak",
    provinceId: 27,
    status: 1,
    regionCityId: 17,
    adCode: "610900",
    glng: 109.02930300000001,
    hotCity: false,
    glat: 32.684781,
  },
  {
    cityId: 243,
    cityName: "广元",
    cityEnName: "guangyuan",
    cityAbbrCode: "gy",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510800",
    glng: 105.84333,
    hotCity: false,
    glat: 32.435442,
  },
  {
    cityId: 250,
    cityName: "广安",
    cityEnName: "guangan",
    cityAbbrCode: "ga",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511600",
    glng: 106.633204,
    hotCity: false,
    glat: 30.45593,
  },
  {
    cityId: 39,
    cityName: "晋城",
    cityEnName: "jincheng",
    cityAbbrCode: "jc",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140500",
    glng: 112.85176800000002,
    hotCity: false,
    glat: 35.49087,
  },
  {
    cityId: 268,
    cityName: "曲靖",
    cityEnName: "qujing",
    cityAbbrCode: "qj1",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "530300",
    glng: 103.796293,
    hotCity: false,
    glat: 25.48999,
  },
  {
    cityId: 248,
    cityName: "眉山",
    cityEnName: "meishan",
    cityAbbrCode: "ms",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511400",
    glng: 103.848462,
    hotCity: false,
    glat: 30.076015,
  },
  {
    cityId: 239,
    cityName: "攀枝花",
    cityEnName: "panzhihua",
    cityAbbrCode: "pzh",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "510400",
    glng: 101.718637,
    hotCity: false,
    glat: 26.582347,
  },
  {
    cityId: 37,
    cityName: "阳泉",
    cityEnName: "yangquan",
    cityAbbrCode: "yq",
    provinceId: 4,
    status: 1,
    regionCityId: 17,
    adCode: "140300",
    glng: 113.580415,
    hotCity: false,
    glat: 37.856658,
  },
  {
    cityId: 254,
    cityName: "资阳",
    cityEnName: "ziyang",
    cityAbbrCode: "zy",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "512000",
    glng: 104.628889,
    hotCity: false,
    glat: 30.129463,
  },
  {
    cityId: 203,
    cityName: "娄底",
    cityEnName: "loudi",
    cityAbbrCode: "ld",
    provinceId: 18,
    status: 1,
    regionCityId: 344,
    adCode: "431300",
    glng: 111.996001,
    hotCity: false,
    glat: 27.701693,
  },
  {
    cityId: 266,
    cityName: "黔南",
    cityEnName: "qiannan",
    cityAbbrCode: "qn",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "522700",
    glng: 107.52214,
    hotCity: false,
    glat: 26.254092,
  },
  {
    cityId: 253,
    cityName: "巴中",
    cityEnName: "bazhong",
    cityAbbrCode: "bz2",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "511900",
    glng: 106.744901,
    hotCity: false,
    glat: 31.865056,
  },
  {
    cityId: 53,
    cityName: "兴安盟",
    cityEnName: "xingan",
    cityAbbrCode: "xa1",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "152200",
    glng: 122.067042,
    hotCity: false,
    glat: 46.077561,
  },
  {
    cityId: 56,
    cityName: "巴彦淖尔",
    cityEnName: "bayannaoer",
    cityAbbrCode: "by",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "150800",
    glng: 107.386669,
    hotCity: false,
    glat: 40.766188,
  },
  {
    cityId: 315,
    cityName: "海北",
    cityEnName: "haibei",
    cityAbbrCode: "hb3",
    provinceId: 29,
    status: 1,
    regionCityId: 17,
    adCode: "632200",
    glng: 100.900931,
    hotCity: false,
    glat: 36.954273,
  },
  {
    cityId: 275,
    cityName: "普洱",
    cityEnName: "puer",
    cityAbbrCode: "sm5",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "530800",
    glng: 100.977165,
    hotCity: false,
    glat: 22.78691,
  },
  {
    cityId: 263,
    cityName: "黔西南",
    cityEnName: "qianxinan",
    cityAbbrCode: "qxn",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "522300",
    glng: 104.906397,
    hotCity: false,
    glat: 25.087825,
  },
  {
    cityId: 54,
    cityName: "锡林郭勒",
    cityEnName: "xilinguole",
    cityAbbrCode: "xlg",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "152500",
    glng: 116.047867,
    hotCity: false,
    glat: 43.933136,
  },
  {
    cityId: 4445,
    cityName: "休斯敦",
    cityEnName: "Houston",
    provinceId: 118,
    status: 1,
    regionCityId: 6,
    glng: 96,
    hotCity: false,
    glat: 30,
  },
  {
    cityId: 4446,
    cityName: "克拉斯诺达尔",
    cityEnName: "Krasnodar",
    provinceId: 162,
    status: 1,
    regionCityId: 6,
    glng: 38.5837,
    hotCity: false,
    glat: 45.158,
  },
  {
    cityId: 4447,
    cityName: "博洛尼亚",
    cityEnName: "Bologna",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 11.2,
    hotCity: false,
    glat: 44.29,
  },
  {
    cityId: 4448,
    cityName: "哈利斯科州",
    cityEnName: "Sapopan halisco",
    provinceId: 142,
    status: 1,
    regionCityId: 6,
    glng: 103.24,
    hotCity: false,
    glat: 20.43,
  },
  {
    cityId: 4449,
    cityName: "哈利斯科州瓜达拉哈拉",
    cityEnName: "Guadalajara hal",
    provinceId: 142,
    status: 1,
    regionCityId: 6,
    glng: 103.21,
    hotCity: false,
    glat: 20.4,
  },
  {
    cityId: 4450,
    cityName: "圣地亚哥·克雷塔罗",
    cityEnName: "Santiago cretar",
    provinceId: 142,
    status: 1,
    regionCityId: 6,
    glng: 100.23177,
    hotCity: false,
    glat: 20.3517,
  },
  {
    cityId: 4451,
    cityName: "墨尔本",
    cityEnName: "Melbourne",
    provinceId: 108,
    status: 1,
    regionCityId: 6,
    glng: 145,
    hotCity: false,
    glat: 38,
  },
  {
    cityId: 4452,
    cityName: "多伦多",
    cityEnName: "Toronto",
    provinceId: 123,
    status: 1,
    regionCityId: 2,
    glng: 80,
    hotCity: false,
    glat: 44,
  },
  {
    cityId: 4453,
    cityName: "多特蒙德",
    cityEnName: "Dortmund",
    provinceId: 126,
    status: 1,
    regionCityId: 2,
    glng: 7,
    hotCity: false,
    glat: 51,
  },
  {
    cityId: 4454,
    cityName: "奥厄",
    cityEnName: "AUE",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 12.416,
    hotCity: false,
    glat: 50.346,
  },
  {
    cityId: 4455,
    cityName: "布宜诺斯艾利斯",
    cityEnName: "Buenos Aires",
    provinceId: 144,
    status: 1,
    regionCityId: 6,
    glng: 58.3,
    hotCity: false,
    glat: 34.2,
  },
  {
    cityId: 4456,
    cityName: "帕尔马",
    cityEnName: "Palma",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 10.19,
    hotCity: false,
    glat: 44.48,
  },
  {
    cityId: 4457,
    cityName: "德累斯顿",
    cityEnName: "Dresden",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 13.4418,
    hotCity: false,
    glat: 51.33,
  },
  {
    cityId: 4458,
    cityName: "慕尼黑",
    cityEnName: "Munich ",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 11.35,
    hotCity: false,
    glat: 48.08,
  },
  {
    cityId: 4459,
    cityName: "杜塞尔多夫",
    cityEnName: "Dusseldorf",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 6.47,
    hotCity: false,
    glat: 51.13,
  },
  {
    cityId: 4461,
    cityName: "汉堡",
    cityEnName: "hamburg",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 4462,
    cityName: "沃尔夫斯堡",
    cityEnName: "Wolfsburg",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 14,
    hotCity: false,
    glat: 46,
  },
  {
    cityId: 4463,
    cityName: "波尔图",
    cityEnName: "Oporto",
    provinceId: 129,
    status: 1,
    regionCityId: 2,
    glng: 8.37,
    hotCity: false,
    glat: 41.09,
  },
  {
    cityId: 4464,
    cityName: "波尔蒂芒市",
    cityEnName: "Poltimon",
    provinceId: 129,
    status: 1,
    regionCityId: 6,
    glng: 9.1,
    hotCity: false,
    glat: 36.58,
  },
  {
    cityId: 4465,
    cityName: "洛杉矶",
    cityEnName: "Los Angeles",
    provinceId: 118,
    status: 1,
    regionCityId: 2,
    glng: 118,
    hotCity: false,
    glat: 34,
  },
  {
    cityId: 4466,
    cityName: "海宁",
    cityEnName: "Herning",
    provinceId: 161,
    status: 1,
    regionCityId: 6,
    glng: 120,
    hotCity: false,
    glat: 30,
  },
  {
    cityId: 4467,
    cityName: "海登海姆",
    cityEnName: "Heidenheim",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 10.96,
    hotCity: false,
    glat: 48.4041,
  },
  {
    cityId: 4468,
    cityName: "热那亚",
    cityEnName: "Genova",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 8.56,
    hotCity: false,
    glat: 44.24,
  },
  {
    cityId: 4469,
    cityName: "盐湖城",
    cityEnName: "Salt Lake City",
    provinceId: 118,
    status: 1,
    regionCityId: 2,
    glng: 112,
    hotCity: false,
    glat: 41,
  },
  {
    cityId: 4470,
    cityName: "米兰",
    cityEnName: "Milan",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 9.1,
    hotCity: false,
    glat: 45.28,
  },
  {
    cityId: 4471,
    cityName: "索契",
    cityEnName: "Sochi",
    provinceId: 162,
    status: 1,
    regionCityId: 6,
    glng: 40,
    hotCity: false,
    glat: 44,
  },
  {
    cityId: 4472,
    cityName: "索非亚",
    cityEnName: "Sofia",
    provinceId: 175,
    status: 1,
    regionCityId: 6,
    glng: 23.2,
    hotCity: false,
    glat: 42.43,
  },
  {
    cityId: 4473,
    cityName: "纽伦堡",
    cityEnName: "Nuremberg",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 11.5,
    hotCity: false,
    glat: 49.27,
  },
  {
    cityId: 4474,
    cityName: "纽卡斯尔",
    cityEnName: "Newcastle",
    provinceId: 108,
    status: 1,
    regionCityId: 6,
    glng: 2,
    hotCity: false,
    glat: 54,
  },
  {
    cityId: 4476,
    cityName: "维拉达斯大街",
    cityEnName: "Villadas Avenue",
    provinceId: 129,
    status: 1,
    regionCityId: 6,
    glng: 7.32,
    hotCity: false,
    glat: 38.23,
  },
  {
    cityId: 4477,
    cityName: "维罗纳",
    cityEnName: "Verona",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 2.0442,
    hotCity: false,
    glat: 41.1749,
  },
  {
    cityId: 4478,
    cityName: "罗马",
    cityEnName: "Roman",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 12,
    hotCity: false,
    glat: 42,
  },
  {
    cityId: 4480,
    cityName: "莱比锡",
    cityEnName: "Leipzig",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 12,
    hotCity: false,
    glat: 51,
  },
  {
    cityId: 4481,
    cityName: "萨马拉",
    cityEnName: "Samara",
    provinceId: 162,
    status: 1,
    regionCityId: 6,
    glng: 50,
    hotCity: false,
    glat: 53,
  },
  {
    cityId: 4482,
    cityName: "蓬塔德尔加达",
    cityEnName: "Punta Delgada",
    provinceId: 129,
    status: 1,
    regionCityId: 6,
    glng: 6.9,
    hotCity: false,
    glat: 42.8,
  },
  {
    cityId: 4483,
    cityName: "那不勒斯",
    cityEnName: "Naples",
    provinceId: 136,
    status: 1,
    regionCityId: 6,
    glng: 14,
    hotCity: false,
    glat: 40,
  },
  {
    cityId: 4484,
    cityName: "里斯本",
    cityEnName: "Lisbon",
    provinceId: 129,
    status: 1,
    regionCityId: 6,
    glng: 9.05,
    hotCity: false,
    glat: 38.42,
  },
  {
    cityId: 4485,
    cityName: "门兴格拉德巴赫",
    cityEnName: "Monchengladbach",
    provinceId: 126,
    status: 1,
    regionCityId: 2,
    glng: 6,
    hotCity: false,
    glat: 51,
  },
  {
    cityId: 4486,
    cityName: "阿姆斯特丹",
    cityEnName: "Amsterdam",
    provinceId: 127,
    status: 1,
    regionCityId: 6,
    glng: 4.53,
    hotCity: false,
    glat: 52.22,
  },
  {
    cityId: 4487,
    cityName: "阿韦利亚内达",
    cityEnName: "Avellaneda",
    provinceId: 144,
    status: 1,
    regionCityId: 6,
    glng: 60.12,
    hotCity: false,
    glat: 42.11,
  },
  {
    cityId: 4488,
    cityName: "雷根斯堡",
    cityEnName: "Regensburg",
    provinceId: 126,
    status: 1,
    regionCityId: 6,
    glng: 12,
    hotCity: false,
    glat: 49,
  },
  {
    cityId: 4489,
    cityName: "顿河畔罗斯托夫",
    cityEnName: "Rostov-on-Don",
    provinceId: 162,
    status: 1,
    regionCityId: 6,
    glng: 39.42,
    hotCity: false,
    glat: 47.14,
  },
  {
    cityId: 45,
    cityName: "吕梁",
    cityEnName: "lvliang",
    cityAbbrCode: "ll",
    provinceId: 4,
    status: 3,
    regionCityId: 17,
    adCode: "141100",
    glng: 111.144138,
    hotCity: false,
    glat: 37.518972,
  },
  {
    cityId: 57,
    cityName: "阿拉善",
    cityEnName: "alashan",
    cityAbbrCode: "als",
    provinceId: 5,
    status: 1,
    regionCityId: 2,
    adCode: "152900",
    glng: 105.728969,
    hotCity: false,
    glat: 38.851892,
  },
  {
    cityId: 2335,
    cityName: "中国台北",
    cityEnName: "taipei",
    cityAbbrCode: "tpe",
    provinceId: 34,
    status: 1,
    regionCityId: 7,
    adCode: "710000",
    glng: 121.538315,
    hotCity: false,
    glat: 25.071295,
  },
  {
    cityId: 2341,
    cityName: "中国台中",
    cityEnName: "taichung",
    cityAbbrCode: "tch",
    provinceId: 34,
    status: 1,
    regionCityId: 7,
    adCode: "710000",
    glng: 120.666667,
    hotCity: false,
    glat: 24.15,
  },
  {
    cityId: 361,
    cityName: "延吉市",
    cityEnName: "yanji",
    cityAbbrCode: "yj10",
    provinceId: 7,
    status: 1,
    regionCityId: 2,
    adCode: "222400",
    glng: 129.513902,
    hotCity: false,
    glat: 42.906921,
  },
  {
    cityId: 385,
    cityName: "义乌",
    cityEnName: "yiwu",
    cityAbbrCode: "yw",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330700",
    glng: 120.075058,
    hotCity: false,
    glat: 29.306841,
  },
  {
    cityId: 416,
    cityName: "昆山",
    cityEnName: "kunshan",
    cityAbbrCode: "ks",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320500",
    glng: 120.982604,
    hotCity: false,
    glat: 31.387641,
  },
  {
    cityId: 417,
    cityName: "常熟",
    cityEnName: "changshu",
    cityAbbrCode: "cs5",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320500",
    glng: 120.75239,
    hotCity: false,
    glat: 31.65355,
  },
  {
    cityId: 421,
    cityName: "慈溪",
    cityEnName: "cixi",
    cityAbbrCode: "cx",
    provinceId: 11,
    status: 1,
    regionCityId: 3,
    adCode: "330200",
    glng: 121.26646,
    hotCity: false,
    glat: 30.16963,
  },
  {
    cityId: 1009,
    cityName: "晋江",
    cityEnName: "jinjiang",
    cityAbbrCode: "jj1",
    provinceId: 13,
    status: 1,
    regionCityId: 4,
    adCode: "350500",
    glng: 118.552433,
    hotCity: false,
    glat: 24.781611,
  },
  {
    cityId: 1118,
    cityName: "章丘",
    cityEnName: "zhangqiu",
    cityAbbrCode: "zq3",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370100",
    glng: 117.53434,
    hotCity: false,
    glat: 36.7142,
  },
  {
    cityId: 2342,
    cityName: "曼谷",
    cityEnName: "bangkok",
    cityAbbrCode: "bkk",
    provinceId: 103,
    status: 1,
    regionCityId: 4,
    glng: 100.493889,
    hotCity: false,
    glat: 13.752222,
  },
  {
    cityId: 2313,
    cityName: "泰国",
    cityEnName: "thailand",
    cityAbbrCode: "th3",
    provinceId: 103,
    status: 1,
    regionCityId: 7,
    glng: 101.092896,
    hotCity: false,
    glat: 15.897942,
  },
  {
    cityId: 2369,
    cityName: "首尔",
    cityEnName: "seoul",
    cityAbbrCode: "sel",
    provinceId: 104,
    status: 1,
    regionCityId: 2,
    glng: 126.980495,
    hotCity: false,
    glat: 37.532871,
  },
  {
    cityId: 2370,
    cityName: "釜山",
    cityEnName: "busan",
    cityAbbrCode: "pus",
    provinceId: 104,
    status: 1,
    regionCityId: 1,
    glng: 129.07545,
    hotCity: false,
    glat: 35.180403,
  },
  {
    cityId: 4490,
    cityName: "高阳",
    cityEnName: "busan",
    cityAbbrCode: "pus",
    provinceId: 104,
    status: 1,
    regionCityId: 18,
    glng: 126.83184,
    hotCity: false,
    glat: 37.66103,
  },
  {
    cityId: 2372,
    cityName: "东京",
    cityEnName: "tokyo",
    cityAbbrCode: "tyo",
    provinceId: 105,
    status: 1,
    regionCityId: 1,
    glng: 139.768753,
    hotCity: false,
    glat: 35.679052,
  },
  {
    cityId: 2374,
    cityName: "大阪",
    cityEnName: "osaka",
    cityAbbrCode: "osa",
    provinceId: 105,
    status: 1,
    regionCityId: 1,
    glng: 135.497818,
    hotCity: false,
    glat: 34.6767,
  },
  {
    cityId: 3145,
    cityName: "迪拜",
    cityEnName: "dubai",
    cityAbbrCode: "dxb",
    provinceId: 160,
    status: 1,
    regionCityId: 1,
    glng: 55.345045,
    hotCity: false,
    glat: 24.995006,
  },
  {
    cityId: 3150,
    cityName: "莫斯科",
    cityEnName: "moscow",
    cityAbbrCode: "mos",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 37.631122,
    hotCity: false,
    glat: 55.735104,
  },
  {
    cityId: 4432,
    cityName: "喀山",
    cityEnName: "gasha",
    cityAbbrCode: "spb",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4433,
    cityName: "索契",
    cityEnName: "suoqi",
    cityAbbrCode: "spb",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4434,
    cityName: "下诺夫哥罗德",
    cityEnName: "xnfgld",
    cityAbbrCode: "xnfgld",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4435,
    cityName: "加里宁格勒",
    cityEnName: "jdngl",
    cityAbbrCode: "jdngl",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4436,
    cityName: "罗斯托夫",
    cityEnName: "lstf",
    cityAbbrCode: "lstf",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4437,
    cityName: "萨马拉",
    cityEnName: "sml",
    cityAbbrCode: "sml",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4438,
    cityName: "萨兰斯克",
    cityEnName: "slsk",
    cityAbbrCode: "slsk",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4439,
    cityName: "伏尔加格勒",
    cityEnName: "frjgl",
    cityAbbrCode: "frjgl",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4440,
    cityName: "叶卡捷琳堡",
    cityEnName: "ykjlb",
    cityAbbrCode: "ykjlb",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 4441,
    cityName: "圣彼得堡",
    cityEnName: "sbdb",
    cityAbbrCode: "sbdb",
    provinceId: 162,
    status: 1,
    regionCityId: 1,
    glng: 30.350463,
    hotCity: false,
    glat: 59.917101,
  },
  {
    cityId: 2311,
    cityName: "新加坡",
    cityEnName: "singapore",
    cityAbbrCode: "sg4",
    provinceId: 101,
    status: 1,
    regionCityId: 4,
    glng: 103.798433,
    hotCity: false,
    glat: 1.369041,
  },
  {
    cityId: 2312,
    cityName: "马来西亚",
    cityEnName: "malaysia",
    cityAbbrCode: "my5",
    provinceId: 102,
    status: 1,
    regionCityId: 4,
    glng: 102.10611,
    hotCity: false,
    glat: 4.559998,
  },
  {
    cityId: 2354,
    cityName: "马尼拉",
    cityEnName: "manila",
    cityAbbrCode: "mnl",
    provinceId: 113,
    status: 1,
    regionCityId: 7,
    glng: 120.976381,
    hotCity: false,
    glat: 14.601026,
  },
  {
    cityId: 2363,
    cityName: "暹粒",
    cityEnName: "siemreap",
    cityAbbrCode: "rep",
    provinceId: 106,
    status: 1,
    regionCityId: 1,
    glng: 103.862171,
    hotCity: false,
    glat: 13.361563,
  },
  {
    cityId: 2379,
    cityName: "悉尼",
    cityEnName: "sydney",
    cityAbbrCode: "syd",
    provinceId: 108,
    status: 1,
    regionCityId: 7,
    glng: 151.205864,
    hotCity: false,
    glat: -33.87013,
  },
  {
    cityId: 2384,
    cityName: "奥克兰",
    cityEnName: "auckland",
    cityAbbrCode: "akl",
    provinceId: 109,
    status: 1,
    regionCityId: 1,
    glng: 174.764843,
    hotCity: false,
    glat: -36.850093,
  },
  {
    cityId: 2388,
    cityName: "巴黎",
    cityEnName: "paris",
    cityAbbrCode: "par",
    provinceId: 117,
    status: 1,
    regionCityId: 8,
    glng: 2.350987,
    hotCity: false,
    glat: 48.856667,
  },
  {
    cityId: 2395,
    cityName: "纽约",
    cityEnName: "newyork",
    cityAbbrCode: "nyc",
    provinceId: 118,
    status: 1,
    regionCityId: 1,
    glng: -74.011459,
    hotCity: false,
    glat: 40.62594,
  },
  {
    cityId: 2397,
    cityName: "洛杉矶",
    cityEnName: "losangeles",
    cityAbbrCode: "lax",
    provinceId: 118,
    status: 1,
    regionCityId: 2,
    glng: -118.243685,
    hotCity: false,
    glat: 34.052234,
  },
  {
    cityId: 2398,
    cityName: "拉斯维加斯",
    cityEnName: "lasvegas",
    cityAbbrCode: "las",
    provinceId: 118,
    status: 1,
    regionCityId: 1,
    glng: -115.188733,
    hotCity: false,
    glat: 36.208704,
  },
  {
    cityId: 2400,
    cityName: "芝加哥",
    cityEnName: "chicago",
    cityAbbrCode: "chi",
    provinceId: 118,
    status: 1,
    regionCityId: 2,
    glng: -87.646866,
    hotCity: false,
    glat: 41.849616,
  },
  {
    cityId: 2403,
    cityName: "波士顿",
    cityEnName: "boston",
    cityAbbrCode: "bos",
    provinceId: 118,
    status: 1,
    regionCityId: 1,
    glng: -71.059773,
    hotCity: false,
    glat: 42.358431,
  },
  {
    cityId: 3106,
    cityName: "华盛顿",
    cityEnName: "washington",
    cityAbbrCode: "dc2",
    provinceId: 118,
    status: 1,
    regionCityId: 1,
    glng: -77.007357,
    hotCity: false,
    glat: 38.910303,
  },
  {
    cityId: 2415,
    cityName: "温哥华",
    cityEnName: "vancouver",
    cityAbbrCode: "wgh",
    provinceId: 123,
    status: 1,
    regionCityId: 2,
    glng: -123.138565,
    hotCity: false,
    glat: 49.263588,
  },
  {
    cityId: 2417,
    cityName: "维也纳",
    cityEnName: "vienna",
    cityAbbrCode: "wyn",
    provinceId: 124,
    status: 1,
    regionCityId: 1,
    glng: 16.372778,
    hotCity: false,
    glat: 48.209206,
  },
  {
    cityId: 343,
    cityName: "国外其他",
    cityEnName: "guowai",
    cityAbbrCode: "gw",
    provinceId: 100,
    status: 1,
    regionCityId: 2,
    adCode: "654000",
    glng: 81.332114,
    hotCity: false,
    glat: 43.914374,
  },
  {
    cityId: 2423,
    cityName: "柏林",
    cityEnName: "berlin",
    cityAbbrCode: "bl4",
    provinceId: 126,
    status: 1,
    regionCityId: 2,
    glng: 13.411494,
    hotCity: false,
    glat: 52.52348,
  },
  {
    cityId: 2449,
    cityName: "巴塞罗纳",
    cityEnName: "barcelona",
    cityAbbrCode: "bsl",
    provinceId: 133,
    status: 1,
    regionCityId: 1,
    glng: 2.169919,
    hotCity: false,
    glat: 41.387917,
  },
  {
    cityId: 2458,
    cityName: "罗马",
    cityEnName: "rome",
    cityAbbrCode: "lm1",
    provinceId: 136,
    status: 1,
    regionCityId: 1,
    glng: 12.482324,
    hotCity: false,
    glat: 41.895466,
  },
  {
    cityId: 3124,
    cityName: "米兰",
    cityEnName: "milano",
    cityAbbrCode: "mil",
    provinceId: 136,
    status: 1,
    regionCityId: 1,
    glng: 9.181337,
    hotCity: false,
    glat: 45.473689,
  },
  {
    cityId: 2464,
    cityName: "伦敦",
    cityEnName: "london",
    cityAbbrCode: "ld10",
    provinceId: 137,
    status: 1,
    regionCityId: 1,
    glng: -0.124454,
    hotCity: false,
    glat: 51.501584,
  },
  {
    cityId: 2467,
    cityName: "曼彻斯特",
    cityEnName: "manchester",
    cityAbbrCode: "mcs",
    provinceId: 137,
    status: 1,
    regionCityId: 2,
    glng: -2.207565,
    hotCity: false,
    glat: 53.479874,
  },
  {
    cityId: 2469,
    cityName: "利物浦",
    cityEnName: "liverpool",
    cityAbbrCode: "lwp",
    provinceId: 137,
    status: 1,
    regionCityId: 2,
    glng: -2.993774,
    hotCity: false,
    glat: 53.411169,
  },
  {
    cityId: 358,
    cityName: "儋州",
    cityEnName: "danzhou",
    cityAbbrCode: "dz4",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    glng: 109.580811,
    hotCity: false,
    glat: 19.521134,
  },
  {
    cityId: 382,
    cityName: "西昌市",
    cityEnName: "xichang",
    cityAbbrCode: "xc9",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "513400",
    glng: 102.264443,
    hotCity: false,
    glat: 27.894496,
  },
  {
    cityId: 396,
    cityName: "东方",
    cityEnName: "dongfang",
    cityAbbrCode: "df",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "469007",
    glng: 108.651775,
    hotCity: false,
    glat: 19.095361,
  },
  {
    cityId: 401,
    cityName: "陵水",
    cityEnName: "lingshui",
    cityAbbrCode: "ls13",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "469028",
    glng: 110.037504,
    hotCity: false,
    glat: 18.506048,
  },
  {
    cityId: 407,
    cityName: "万宁",
    cityEnName: "wanning",
    cityAbbrCode: "wn1",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "469006",
    glng: 110.391073,
    hotCity: false,
    glat: 18.795143,
  },
  {
    cityId: 410,
    cityName: "五指山",
    cityEnName: "wuzhishan",
    cityAbbrCode: "wzs",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "469001",
    glng: 109.516925,
    hotCity: false,
    glat: 18.775147,
  },
  {
    cityId: 490,
    cityName: "三河市",
    cityEnName: "sanhe",
    cityAbbrCode: "sh4",
    provinceId: 3,
    status: 1,
    regionCityId: 2,
    adCode: "131000",
    glng: 117.07822,
    hotCity: false,
    glat: 39.98246,
  },
  {
    cityId: 710,
    cityName: "凤城市",
    cityEnName: "fengcheng",
    cityAbbrCode: "fc1",
    provinceId: 6,
    status: 1,
    regionCityId: 2,
    adCode: "210600",
    glng: 124.06605,
    hotCity: false,
    glat: 40.45279,
  },
  {
    cityId: 796,
    cityName: "同江市",
    cityEnName: "tongjiang",
    cityAbbrCode: "tj1",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "230800",
    glng: 132.51101,
    hotCity: false,
    glat: 47.6421,
  },
  {
    cityId: 826,
    cityName: "漠河县",
    cityEnName: "mohe",
    cityAbbrCode: "mh",
    provinceId: 8,
    status: 1,
    regionCityId: 2,
    adCode: "232700",
    glng: 122.53911,
    hotCity: false,
    glat: 52.97215,
  },
  {
    cityId: 845,
    cityName: "东台市",
    cityEnName: "dongtai",
    cityAbbrCode: "dt5",
    provinceId: 10,
    status: 1,
    regionCityId: 5,
    adCode: "320900",
    glng: 120.32107,
    hotCity: false,
    glat: 32.86713,
  },
  {
    cityId: 1030,
    cityName: "福安市",
    cityEnName: "fuan",
    cityAbbrCode: "fa",
    provinceId: 13,
    status: 1,
    regionCityId: 4,
    adCode: "350900",
    glng: 119.6477,
    hotCity: false,
    glat: 27.088,
  },
  {
    cityId: 1146,
    cityName: "昌邑市",
    cityEnName: "cangyi",
    cityAbbrCode: "cy1",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370700",
    glng: 119.39845,
    hotCity: false,
    glat: 36.85885,
  },
  {
    cityId: 1348,
    cityName: "赤壁市",
    cityEnName: "chibi",
    cityAbbrCode: "cb1",
    provinceId: 17,
    status: 1,
    regionCityId: 16,
    adCode: "421200",
    glng: 113.90054,
    hotCity: false,
    glat: 29.72476,
  },
  {
    cityId: 1467,
    cityName: "阳山县",
    cityEnName: "yangshan",
    cityAbbrCode: "ys9",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "441800",
    glng: 112.64122,
    hotCity: false,
    glat: 24.46506,
  },
  {
    cityId: 1604,
    cityName: "都江堰市",
    cityEnName: "dujiangyan",
    cityAbbrCode: "djy",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 1605,
    cityName: "彭州市",
    cityEnName: "pengzhou",
    cityAbbrCode: "pz2",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 1607,
    cityName: "崇州市",
    cityEnName: "chongzhou",
    cityAbbrCode: "cz6",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 1695,
    cityName: "汶川县",
    cityEnName: "wenchuan",
    cityAbbrCode: "wc3",
    provinceId: 23,
    status: 1,
    regionCityId: 8,
    adCode: "513200",
    glng: 103.5903,
    hotCity: false,
    glat: 31.47686,
  },
  {
    cityId: 1762,
    cityName: "毕节市",
    cityEnName: "bijie",
    cityAbbrCode: "bj3",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    glng: 0,
    hotCity: false,
    glat: 0,
  },
  {
    cityId: 1770,
    cityName: "铜仁市",
    cityEnName: "tongren",
    cityAbbrCode: "tr",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "520600",
    glng: 109.18962,
    hotCity: false,
    glat: 27.73156,
  },
  {
    cityId: 1807,
    cityName: "兴义市",
    cityEnName: "xingyi",
    cityAbbrCode: "xy4",
    provinceId: 24,
    status: 1,
    regionCityId: 8,
    adCode: "522300",
    glng: 104.89529,
    hotCity: false,
    glat: 25.09194,
  },
  {
    cityId: 1898,
    cityName: "楚雄市",
    cityEnName: "chuxiong",
    cityAbbrCode: "cx4",
    provinceId: 25,
    status: 1,
    regionCityId: 267,
    adCode: "532300",
    glng: 101.54586,
    hotCity: false,
    glat: 25.03286,
  },
  {
    cityId: 2140,
    cityName: "临夏市",
    cityEnName: "linxia",
    cityAbbrCode: "lx14",
    provinceId: 28,
    status: 1,
    regionCityId: 17,
    adCode: "622900",
    glng: 103.24317,
    hotCity: false,
    glat: 35.6045,
  },
  {
    cityId: 2268,
    cityName: "塔城市",
    cityEnName: "tacheng",
    cityAbbrCode: "tc6",
    provinceId: 31,
    status: 1,
    regionCityId: 17,
    adCode: "654200",
    glng: 82.98703,
    hotCity: false,
    glat: 46.75144,
  },
  {
    cityId: 4442,
    cityName: "西藏",
    cityEnName: "xizang",
    cityAbbrCode: "sn1000",
    provinceId: 26,
    status: 1,
    regionCityId: 2,
    adCode: "3509000",
    glng: 119.51521,
    hotCity: false,
    glat: 27.45487,
  },
];
export const hotCities = [
  {
    cityId: 1,
    cityName: "上海",
    cityEnName: "shanghai",
    cityAbbrCode: "sh",
    provinceId: 9,
    status: 3,
    regionCityId: 1,
    adCode: "310100",
    hotCity: true,
    glat: 31.230708,
    glng: 121.472916,
  },
  {
    cityId: 7,
    cityName: "深圳",
    cityEnName: "shenzhen",
    cityAbbrCode: "sz",
    provinceId: 19,
    status: 3,
    regionCityId: 7,
    adCode: "440300",
    hotCity: true,
    glat: 22.543447,
    glng: 114.057818,
  },
  {
    cityId: 2,
    cityName: "北京",
    cityEnName: "beijing",
    cityAbbrCode: "bj",
    provinceId: 1,
    status: 3,
    regionCityId: 2,
    adCode: "110100",
    hotCity: true,
    glat: 39.904667,
    glng: 116.408198,
  },
  {
    cityId: 8,
    cityName: "成都",
    cityEnName: "chengdu",
    cityAbbrCode: "cd",
    provinceId: 23,
    status: 3,
    regionCityId: 8,
    adCode: "510100",
    hotCity: true,
    glat: 30.658602,
    glng: 104.064857,
  },
  {
    cityId: 16,
    cityName: "武汉",
    cityEnName: "wuhan",
    cityAbbrCode: "wh",
    provinceId: 17,
    status: 3,
    regionCityId: 16,
    adCode: "420100",
    hotCity: true,
    glat: 30.593088,
    glng: 114.305172,
  },
  {
    cityId: 3,
    cityName: "杭州",
    cityEnName: "hangzhou",
    cityAbbrCode: "hz",
    provinceId: 11,
    status: 3,
    regionCityId: 3,
    adCode: "330100",
    hotCity: true,
    glat: 30.273497,
    glng: 120.155249,
  },
  {
    cityId: 5,
    cityName: "南京",
    cityEnName: "nanjing",
    cityAbbrCode: "nj",
    provinceId: 10,
    status: 3,
    regionCityId: 5,
    adCode: "320100",
    hotCity: true,
    glat: 32.058365,
    glng: 118.796468,
  },
  {
    cityId: 9,
    cityName: "重庆",
    cityEnName: "chongqing",
    cityAbbrCode: "cq",
    provinceId: 22,
    status: 3,
    regionCityId: 9,
    adCode: "500100",
    hotCity: true,
    glat: 29.562686,
    glng: 106.551234,
  },
  {
    cityId: 4,
    cityName: "广州",
    cityEnName: "guangzhou",
    cityAbbrCode: "gz",
    provinceId: 19,
    status: 3,
    regionCityId: 4,
    adCode: "440100",
    hotCity: true,
    glat: 23.129075,
    glng: 113.264423,
  },
  {
    cityId: 21,
    cityName: "青岛",
    cityEnName: "qingdao",
    cityAbbrCode: "qd",
    provinceId: 15,
    status: 1,
    regionCityId: 2,
    adCode: "370200",
    hotCity: true,
    glat: 36.066348,
    glng: 120.382771,
  },
  {
    cityId: 17,
    cityName: "西安",
    cityEnName: "xian",
    cityAbbrCode: "xa",
    provinceId: 27,
    status: 3,
    regionCityId: 17,
    adCode: "610100",
    hotCity: true,
    glat: 34.26488,
    glng: 108.944265,
  },
  {
    cityId: 160,
    cityName: "郑州",
    cityEnName: "zhengzhou",
    cityAbbrCode: "zz11",
    provinceId: 16,
    status: 3,
    regionCityId: 160,
    adCode: "410100",
    hotCity: true,
    glat: 34.747285,
    glng: 113.624863,
  },
  {
    cityId: 208,
    cityName: "佛山",
    cityEnName: "foshan",
    cityAbbrCode: "fs5",
    provinceId: 19,
    status: 1,
    regionCityId: 4,
    adCode: "440600",
    hotCity: true,
    glat: 23.021721,
    glng: 113.121316,
  },
  {
    cityId: 110,
    cityName: "合肥",
    cityEnName: "hefei",
    cityAbbrCode: "hf",
    provinceId: 12,
    status: 1,
    regionCityId: 5,
    adCode: "340100",
    hotCity: true,
    glat: 31.865779,
    glng: 117.286983,
  },
  {
    cityId: 22,
    cityName: "济南",
    cityEnName: "jinan",
    cityAbbrCode: "jn",
    provinceId: 15,
    status: 1,
    regionCityId: 155,
    adCode: "370100",
    hotCity: true,
    glat: 36.665282,
    glng: 116.994915,
  },
  {
    cityId: 15,
    cityName: "厦门",
    cityEnName: "xiamen",
    cityAbbrCode: "xm",
    provinceId: 13,
    status: 1,
    regionCityId: 7,
    adCode: "350200",
    hotCity: true,
    glat: 24.479615,
    glng: 118.08939,
  },
  {
    cityId: 11,
    cityName: "宁波",
    cityEnName: "ningbo",
    cityAbbrCode: "nb",
    provinceId: 11,
    status: 3,
    regionCityId: 11,
    adCode: "330200",
    hotCity: true,
    glat: 29.868336,
    glng: 121.54399,
  },
  {
    cityId: 6,
    cityName: "苏州",
    cityEnName: "suzhou",
    cityAbbrCode: "suz",
    provinceId: 10,
    status: 3,
    regionCityId: 6,
    adCode: "320500",
    hotCity: true,
    glat: 31.297779,
    glng: 120.585586,
  },
  {
    cityId: 10,
    cityName: "天津",
    cityEnName: "tianjin",
    cityAbbrCode: "tj",
    provinceId: 2,
    status: 3,
    regionCityId: 2,
    adCode: "120100",
    hotCity: true,
    glat: 39.120876,
    glng: 117.21503,
  },
  {
    cityId: 345,
    cityName: "三亚",
    cityEnName: "sanya",
    cityAbbrCode: "sy13",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "460200",
    hotCity: true,
    glat: 18.252847,
    glng: 109.511909,
  },
  {
    cityId: 18,
    cityName: "沈阳",
    cityEnName: "shenyang",
    cityAbbrCode: "sy",
    provinceId: 6,
    status: 3,
    regionCityId: 18,
    adCode: "210100",
    hotCity: true,
    glat: 41.807321,
    glng: 123.43045,
  },
  {
    cityId: 344,
    cityName: "长沙",
    cityEnName: "changsha",
    cityAbbrCode: "cs",
    provinceId: 18,
    status: 3,
    regionCityId: 344,
    adCode: "430100",
    hotCity: true,
    glat: 28.228528,
    glng: 112.938827,
  },
  {
    cityId: 341,
    cityName: "中国香港",
    cityEnName: "hongkong",
    cityAbbrCode: "hk3",
    provinceId: 32,
    status: 3,
    regionCityId: 341,
    hotCity: true,
    glat: 22.282346,
    glng: 114.172754,
  },
  {
    cityId: 23,
    cityName: "海口",
    cityEnName: "haikou",
    cityAbbrCode: "hk",
    provinceId: 21,
    status: 1,
    regionCityId: 4,
    adCode: "460100",
    hotCity: true,
    glat: 20.030765,
    glng: 110.328873,
  },
  {
    cityId: 342,
    cityName: "中国澳门",
    cityEnName: "macau",
    cityAbbrCode: "am",
    provinceId: 33,
    status: 1,
    regionCityId: 7,
    hotCity: true,
    glat: 22.198745,
    glng: 113.543873,
  },
  {
    cityId: 2335,
    cityName: "中国台北",
    cityEnName: "taipei",
    cityAbbrCode: "tpe",
    provinceId: 34,
    status: 1,
    regionCityId: 7,
    adCode: "710000",
    hotCity: true,
    glat: 25.071295,
    glng: 121.538315,
  },
];
export const activeCities = [
  {
    cityName: "阿坝",
    GLat: 31.899413,
    cityAbbrCode: "ab",
    cityEnName: "aba",
    cityId: 255,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "A",
    GLng: 102.224653,
    status: 1,
  },
  {
    cityName: "阿拉善",
    adCode: "152900",
    GLat: 38.851892,
    cityAbbrCode: "als",
    cityEnName: "alashan",
    cityId: 57,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "A",
    GLng: 105.728969,
    status: 1,
  },
  {
    cityName: "宿州",
    adCode: "341300",
    GLat: 33.639394,
    cityAbbrCode: "sz5",
    cityEnName: "anhuisuzhou",
    cityId: 121,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "A",
    GLng: 116.985301,
    status: 1,
  },
  {
    cityName: "安康",
    adCode: "610900",
    GLat: 32.684781,
    cityAbbrCode: "ak",
    cityEnName: "ankang",
    cityId: 297,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "A",
    GLng: 109.02930300000001,
    status: 1,
  },
  {
    cityName: "安庆",
    adCode: "340800",
    GLat: 30.524961,
    cityAbbrCode: "aq",
    cityEnName: "anqing",
    cityId: 117,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "A",
    GLng: 117.05673,
    status: 1,
  },
  {
    cityName: "鞍山",
    adCode: "210300",
    GLat: 41.108546,
    cityAbbrCode: "as",
    cityEnName: "anshan",
    cityId: 58,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "A",
    GLng: 122.994646,
    status: 1,
  },
  {
    cityName: "安顺",
    adCode: "520400",
    GLat: 26.253072,
    cityAbbrCode: "as3",
    cityEnName: "anshun",
    cityId: 261,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "A",
    GLng: 105.947594,
    status: 1,
  },
  {
    cityName: "安阳",
    adCode: "410500",
    GLat: 36.097593,
    cityAbbrCode: "ay",
    cityEnName: "anyang",
    cityId: 164,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "A",
    GLng: 114.392756,
    status: 1,
  },
  {
    cityName: "中国澳门",
    GLat: 22.198745,
    cityAbbrCode: "am",
    cityEnName: "aomen",
    cityId: 342,
    hotCity: false,
    regionCityId: 7,
    provinceId: 33,
    firstLetter: "A",
    GLng: 113.543873,
    status: 1,
  },
  {
    cityName: "曼谷",
    GLat: 13.752222,
    cityAbbrCode: "bkk",
    cityEnName: "bangkok",
    cityId: 2342,
    hotCity: false,
    regionCityId: 4,
    provinceId: 103,
    firstLetter: "B",
    GLng: 100.493889,
    status: 1,
  },
  {
    cityName: "保定",
    adCode: "130600",
    GLat: 38.873972,
    cityAbbrCode: "bd",
    cityEnName: "baoding",
    cityId: 29,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "B",
    GLng: 115.46463,
    status: 1,
  },
  {
    cityName: "宝鸡",
    adCode: "610300",
    GLat: 34.372529,
    cityAbbrCode: "bj1",
    cityEnName: "baoji",
    cityId: 291,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "B",
    GLng: 107.133785,
    status: 1,
  },
  {
    cityName: "包头",
    adCode: "150200",
    GLat: 40.657447,
    cityAbbrCode: "bt",
    cityEnName: "baotou",
    cityId: 47,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "B",
    GLng: 109.840385,
    status: 1,
  },
  {
    cityName: "巴彦淖尔",
    adCode: "150800",
    GLat: 40.766188,
    cityAbbrCode: "by",
    cityEnName: "bayannaoer",
    cityId: 56,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "B",
    GLng: 107.386669,
    status: 1,
  },
  {
    cityName: "巴中",
    adCode: "511900",
    GLat: 31.865056,
    cityAbbrCode: "bz2",
    cityEnName: "bazhong",
    cityId: 253,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "B",
    GLng: 106.744901,
    status: 1,
  },
  {
    cityName: "北海",
    adCode: "450500",
    GLat: 21.481198,
    cityAbbrCode: "bh",
    cityEnName: "beihai",
    cityId: 228,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "B",
    GLng: 109.119951,
    status: 1,
  },
  {
    cityName: "北京",
    adCode: "110100",
    GLat: 39.904667,
    cityAbbrCode: "bj",
    cityEnName: "beijing",
    cityId: 2,
    hotCity: false,
    regionCityId: 2,
    provinceId: 1,
    firstLetter: "B",
    GLng: 116.408198,
    status: 3,
  },
  {
    cityName: "蚌埠",
    adCode: "340300",
    GLat: 32.916282,
    cityAbbrCode: "bb",
    cityEnName: "bengbu",
    cityId: 112,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "B",
    GLng: 117.38971,
    status: 1,
  },
  {
    cityName: "本溪",
    adCode: "210500",
    GLat: 41.294176,
    cityAbbrCode: "bx",
    cityEnName: "benxi",
    cityId: 60,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "B",
    GLng: 123.766485,
    status: 1,
  },
  {
    cityName: "毕节市",
    GLat: 0,
    cityAbbrCode: "bj3",
    cityEnName: "bijie",
    cityId: 1762,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "B",
    GLng: 0,
    status: 1,
  },
  {
    cityName: "滨州",
    adCode: "371600",
    GLat: 37.381403,
    cityAbbrCode: "bz1",
    cityEnName: "binzhou",
    cityId: 158,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "B",
    GLng: 117.97143,
    status: 1,
  },
  {
    cityName: "亳州",
    adCode: "341600",
    GLat: 33.844582,
    cityAbbrCode: "bz",
    cityEnName: "bozhou",
    cityId: 124,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "B",
    GLng: 115.778676,
    status: 1,
  },
  {
    cityName: "昌邑市",
    adCode: "370700",
    GLat: 36.85885,
    cityAbbrCode: "cy1",
    cityEnName: "cangyi",
    cityId: 1146,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "C",
    GLng: 119.39845,
    status: 1,
  },
  {
    cityName: "沧州",
    adCode: "130900",
    GLat: 38.304449,
    cityAbbrCode: "cz",
    cityEnName: "cangzhou",
    cityId: 32,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "C",
    GLng: 116.83884,
    status: 1,
  },
  {
    cityName: "长春",
    adCode: "220100",
    GLat: 43.886841,
    cityAbbrCode: "cc",
    cityEnName: "changchun",
    cityId: 70,
    hotCity: false,
    regionCityId: 2,
    provinceId: 7,
    firstLetter: "C",
    GLng: 125.3245,
    status: 1,
  },
  {
    cityName: "常德",
    adCode: "430700",
    GLat: 29.031439,
    cityAbbrCode: "cd3",
    cityEnName: "changde",
    cityId: 197,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "C",
    GLng: 111.698826,
    status: 1,
  },
  {
    cityName: "长沙",
    adCode: "430100",
    GLat: 28.228528,
    cityAbbrCode: "cs",
    cityEnName: "changsha",
    cityId: 344,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "C",
    GLng: 112.938827,
    status: 3,
  },
  {
    cityName: "常熟",
    adCode: "320500",
    GLat: 31.65355,
    cityAbbrCode: "cs5",
    cityEnName: "changshu",
    cityId: 417,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "C",
    GLng: 120.75239,
    status: 1,
  },
  {
    cityName: "长治",
    adCode: "140400",
    GLat: 36.195386,
    cityAbbrCode: "cz3",
    cityEnName: "changzhi",
    cityId: 38,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "C",
    GLng: 113.116255,
    status: 1,
  },
  {
    cityName: "常州",
    adCode: "320400",
    GLat: 31.810077,
    cityAbbrCode: "cz5",
    cityEnName: "changzhou",
    cityId: 93,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "C",
    GLng: 119.974454,
    status: 1,
  },
  {
    cityName: "朝阳",
    adCode: "211300",
    GLat: 41.573733999999995,
    cityAbbrCode: "cy",
    cityEnName: "chaoyang",
    cityId: 68,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "C",
    GLng: 120.450372,
    status: 1,
  },
  {
    cityName: "潮州",
    adCode: "445100",
    GLat: 23.656722,
    cityAbbrCode: "cz1",
    cityEnName: "chaozhou",
    cityId: 221,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "C",
    GLng: 116.623417,
    status: 1,
  },
  {
    cityName: "承德",
    adCode: "130800",
    GLat: 40.978744,
    cityAbbrCode: "cd2",
    cityEnName: "chengde",
    cityId: 31,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "C",
    GLng: 117.943621,
    status: 1,
  },
  {
    cityName: "成都",
    adCode: "510100",
    GLat: 30.658602,
    cityAbbrCode: "cd",
    cityEnName: "chengdu",
    cityId: 8,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "C",
    GLng: 104.064857,
    status: 3,
  },
  {
    cityName: "郴州",
    adCode: "431000",
    GLat: 25.77051,
    cityAbbrCode: "cz9",
    cityEnName: "chenzhou",
    cityId: 200,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "C",
    GLng: 113.014718,
    status: 1,
  },
  {
    cityName: "赤壁市",
    adCode: "421200",
    GLat: 29.72476,
    cityAbbrCode: "cb1",
    cityEnName: "chibi",
    cityId: 1348,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "C",
    GLng: 113.90054,
    status: 1,
  },
  {
    cityName: "赤峰",
    adCode: "150400",
    GLat: 42.257817,
    cityAbbrCode: "cf",
    cityEnName: "chifeng",
    cityId: 49,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "C",
    GLng: 118.886856,
    status: 1,
  },
  {
    cityName: "重庆",
    adCode: "500100",
    GLat: 29.562686,
    cityAbbrCode: "cq",
    cityEnName: "chongqing",
    cityId: 9,
    hotCity: false,
    regionCityId: 9,
    provinceId: 22,
    firstLetter: "C",
    GLng: 106.551234,
    status: 3,
  },
  {
    cityName: "崇州市",
    GLat: 0,
    cityAbbrCode: "cz6",
    cityEnName: "chongzhou",
    cityId: 1607,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "C",
    GLng: 0,
    status: 1,
  },
  {
    cityName: "楚雄市",
    adCode: "532300",
    GLat: 25.03286,
    cityAbbrCode: "cx4",
    cityEnName: "chuxiong",
    cityId: 1898,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "C",
    GLng: 101.54586,
    status: 1,
  },
  {
    cityName: "滁州",
    adCode: "341100",
    GLat: 32.301556,
    cityAbbrCode: "cz7",
    cityEnName: "chuzhou",
    cityId: 119,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "C",
    GLng: 118.317107,
    status: 1,
  },
  {
    cityName: "慈溪",
    adCode: "330200",
    GLat: 30.16963,
    cityAbbrCode: "cx",
    cityEnName: "cixi",
    cityId: 421,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "C",
    GLng: 121.26646,
    status: 1,
  },
  {
    cityName: "大理州",
    adCode: "532900",
    GLat: 25.606486,
    cityAbbrCode: "dl4",
    cityEnName: "dali",
    cityId: 277,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "D",
    GLng: 100.267638,
    status: 1,
  },
  {
    cityName: "大连",
    adCode: "210200",
    GLat: 38.913779,
    cityAbbrCode: "dl",
    cityEnName: "dalian",
    cityId: 19,
    hotCity: false,
    regionCityId: 18,
    provinceId: 6,
    firstLetter: "D",
    GLng: 121.614771,
    status: 1,
  },
  {
    cityName: "丹东",
    adCode: "210600",
    GLat: 40.127344,
    cityAbbrCode: "dd",
    cityEnName: "dandong",
    cityId: 61,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "D",
    GLng: 124.384913,
    status: 1,
  },
  {
    cityName: "儋州",
    GLat: 19.521134,
    cityAbbrCode: "dz4",
    cityEnName: "danzhou",
    cityId: 358,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "D",
    GLng: 109.580811,
    status: 1,
  },
  {
    cityName: "大庆",
    adCode: "230600",
    GLat: 46.59019,
    cityAbbrCode: "dq",
    cityEnName: "daqing",
    cityId: 84,
    hotCity: false,
    regionCityId: 2,
    provinceId: 8,
    firstLetter: "D",
    GLng: 125.104637,
    status: 1,
  },
  {
    cityName: "大同",
    adCode: "140200",
    GLat: 40.076816,
    cityAbbrCode: "dt",
    cityEnName: "datong",
    cityId: 36,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "D",
    GLng: 113.300126,
    status: 1,
  },
  {
    cityName: "达州",
    adCode: "511700",
    GLat: 31.209572,
    cityAbbrCode: "dz2",
    cityEnName: "dazhou",
    cityId: 251,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "D",
    GLng: 107.468023,
    status: 1,
  },
  {
    cityName: "德阳",
    adCode: "510600",
    GLat: 31.127537,
    cityAbbrCode: "dy4",
    cityEnName: "deyang",
    cityId: 241,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "D",
    GLng: 104.397808,
    status: 1,
  },
  {
    cityName: "德州",
    adCode: "371400",
    GLat: 37.45092,
    cityAbbrCode: "dz",
    cityEnName: "dezhou",
    cityId: 156,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "D",
    GLng: 116.302587,
    status: 1,
  },
  {
    cityName: "东方",
    adCode: "469007",
    GLat: 19.095361,
    cityAbbrCode: "df",
    cityEnName: "dongfang",
    cityId: 396,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "D",
    GLng: 108.651775,
    status: 1,
  },
  {
    cityName: "东莞",
    adCode: "441900",
    GLat: 23.020536,
    cityAbbrCode: "dg",
    cityEnName: "dongguan",
    cityId: 219,
    hotCity: false,
    regionCityId: 219,
    provinceId: 19,
    firstLetter: "D",
    GLng: 113.751766,
    status: 3,
  },
  {
    cityName: "东营",
    adCode: "370500",
    GLat: 37.435382,
    cityAbbrCode: "dy",
    cityEnName: "dongying",
    cityId: 147,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "D",
    GLng: 118.675487,
    status: 1,
  },
  {
    cityName: "都江堰市",
    GLat: 0,
    cityAbbrCode: "djy",
    cityEnName: "dujiangyan",
    cityId: 1604,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "D",
    GLng: 0,
    status: 1,
  },
  {
    cityName: "鄂尔多斯",
    adCode: "150600",
    GLat: 39.608182,
    cityAbbrCode: "ee",
    cityEnName: "eerduosi",
    cityId: 51,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "E",
    GLng: 109.781202,
    status: 1,
  },
  {
    cityName: "恩施",
    adCode: "422800",
    GLat: 30.272204,
    cityAbbrCode: "esz",
    cityEnName: "enshizhou",
    cityId: 188,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "E",
    GLng: 109.488162,
    status: 1,
  },
  {
    cityName: "凤城市",
    adCode: "210600",
    GLat: 40.45279,
    cityAbbrCode: "fc1",
    cityEnName: "fengcheng",
    cityId: 710,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "F",
    GLng: 124.06605,
    status: 1,
  },
  {
    cityName: "佛山",
    adCode: "440600",
    GLat: 23.021721,
    cityAbbrCode: "fs5",
    cityEnName: "foshan",
    cityId: 208,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "F",
    GLng: 113.121316,
    status: 1,
  },
  {
    cityName: "福安市",
    adCode: "350900",
    GLat: 27.088,
    cityAbbrCode: "fa",
    cityEnName: "fuan",
    cityId: 1030,
    hotCity: false,
    regionCityId: 4,
    provinceId: 13,
    firstLetter: "F",
    GLng: 119.6477,
    status: 1,
  },
  {
    cityName: "抚顺",
    adCode: "210400",
    GLat: 41.880701,
    cityAbbrCode: "fs",
    cityEnName: "fushun",
    cityId: 59,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "F",
    GLng: 123.915237,
    status: 1,
  },
  {
    cityName: "阜新",
    adCode: "210900",
    GLat: 42.02162,
    cityAbbrCode: "fx",
    cityEnName: "fuxin",
    cityId: 64,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "F",
    GLng: 121.670326,
    status: 1,
  },
  {
    cityName: "阜阳",
    adCode: "341200",
    GLat: 32.890124,
    cityAbbrCode: "fy",
    cityEnName: "fuyang",
    cityId: 120,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "F",
    GLng: 115.814144,
    status: 1,
  },
  {
    cityName: "福州",
    adCode: "350100",
    GLat: 26.074286,
    cityAbbrCode: "fz",
    cityEnName: "fuzhou",
    cityId: 14,
    hotCity: false,
    regionCityId: 14,
    provinceId: 13,
    firstLetter: "F",
    GLng: 119.296579,
    status: 3,
  },
  {
    cityName: "赣州",
    adCode: "360700",
    GLat: 25.829209,
    cityAbbrCode: "gz2",
    cityEnName: "ganzhou",
    cityId: 140,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "G",
    GLng: 114.933553,
    status: 1,
  },
  {
    cityName: "广安",
    adCode: "511600",
    GLat: 30.45593,
    cityAbbrCode: "ga",
    cityEnName: "guangan",
    cityId: 250,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "G",
    GLng: 106.633204,
    status: 1,
  },
  {
    cityName: "玉林",
    adCode: "450900",
    GLat: 22.636379,
    cityAbbrCode: "yl",
    cityEnName: "guangxiyulin",
    cityId: 232,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "G",
    GLng: 110.164756,
    status: 1,
  },
  {
    cityName: "广元",
    adCode: "510800",
    GLat: 32.435442,
    cityAbbrCode: "gy",
    cityEnName: "guangyuan",
    cityId: 243,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "G",
    GLng: 105.84333,
    status: 1,
  },
  {
    cityName: "广州",
    adCode: "440100",
    GLat: 23.129075,
    cityAbbrCode: "gz",
    cityEnName: "guangzhou",
    cityId: 4,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "G",
    GLng: 113.264423,
    status: 3,
  },
  {
    cityName: "贵港",
    adCode: "450800",
    GLat: 23.111531,
    cityAbbrCode: "gg",
    cityEnName: "guigang",
    cityId: 231,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "G",
    GLng: 109.598927,
    status: 1,
  },
  {
    cityName: "桂林",
    adCode: "450300",
    GLat: 25.273567,
    cityAbbrCode: "gl",
    cityEnName: "guilin",
    cityId: 226,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "G",
    GLng: 110.290195,
    status: 1,
  },
  {
    cityName: "贵阳",
    adCode: "520100",
    GLat: 26.578343,
    cityAbbrCode: "gy1",
    cityEnName: "guiyang",
    cityId: 258,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "G",
    GLng: 106.713478,
    status: 1,
  },
  {
    cityName: "哈尔滨",
    adCode: "230100",
    GLat: 45.756967,
    cityAbbrCode: "hb",
    cityEnName: "haerbin",
    cityId: 79,
    hotCity: false,
    regionCityId: 2,
    provinceId: 8,
    firstLetter: "H",
    GLng: 126.642464,
    status: 1,
  },
  {
    cityName: "海口",
    adCode: "460100",
    GLat: 20.030765,
    cityAbbrCode: "hk",
    cityEnName: "haikou",
    cityId: 23,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "H",
    GLng: 110.328873,
    status: 1,
  },
  {
    cityName: "邯郸",
    adCode: "130400",
    GLat: 36.612267,
    cityAbbrCode: "hd",
    cityEnName: "handan",
    cityId: 27,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "H",
    GLng: 114.492968,
    status: 1,
  },
  {
    cityName: "杭州",
    adCode: "330100",
    GLat: 30.273497,
    cityAbbrCode: "hz",
    cityEnName: "hangzhou",
    cityId: 3,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "H",
    GLng: 120.155249,
    status: 3,
  },
  {
    cityName: "合肥",
    adCode: "340100",
    GLat: 31.865779,
    cityAbbrCode: "hf",
    cityEnName: "hefei",
    cityId: 110,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "H",
    GLng: 117.286983,
    status: 1,
  },
  {
    cityName: "衡水",
    adCode: "131100",
    GLat: 37.735302,
    cityAbbrCode: "hs",
    cityEnName: "hengshui",
    cityId: 34,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "H",
    GLng: 115.69868,
    status: 1,
  },
  {
    cityName: "衡阳",
    adCode: "430400",
    GLat: 26.893839,
    cityAbbrCode: "hy",
    cityEnName: "hengyang",
    cityId: 194,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "H",
    GLng: 112.5719,
    status: 1,
  },
  {
    cityName: "海宁",
    GLat: 30,
    cityEnName: "Herning",
    cityId: 4466,
    hotCity: false,
    regionCityId: 6,
    provinceId: 161,
    firstLetter: "H",
    GLng: 120,
    status: 1,
  },
  {
    cityName: "河源",
    adCode: "441600",
    GLat: 23.743538,
    cityAbbrCode: "hy3",
    cityEnName: "heyuan",
    cityId: 216,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "H",
    GLng: 114.700446,
    status: 1,
  },
  {
    cityName: "菏泽",
    adCode: "371700",
    GLat: 35.23375,
    cityAbbrCode: "hz2",
    cityEnName: "heze",
    cityId: 159,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "H",
    GLng: 115.480656,
    status: 1,
  },
  {
    cityName: "贺州",
    adCode: "451100",
    GLat: 24.40357,
    cityAbbrCode: "hz7",
    cityEnName: "hezhou",
    cityId: 234,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "H",
    GLng: 111.566753,
    status: 1,
  },
  {
    cityName: "淮安",
    adCode: "320800",
    GLat: 33.611084,
    cityAbbrCode: "ha",
    cityEnName: "huaian",
    cityId: 96,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "H",
    GLng: 119.015755,
    status: 1,
  },
  {
    cityName: "淮北",
    adCode: "340600",
    GLat: 33.955479,
    cityAbbrCode: "hb1",
    cityEnName: "huaibei",
    cityId: 115,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "H",
    GLng: 116.798218,
    status: 1,
  },
  {
    cityName: "怀化",
    adCode: "431200",
    GLat: 27.554978,
    cityAbbrCode: "hh2",
    cityEnName: "huaihua",
    cityId: 202,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "H",
    GLng: 109.99848799999998,
    status: 1,
  },
  {
    cityName: "淮南",
    adCode: "340400",
    GLat: 32.625397,
    cityAbbrCode: "hn",
    cityEnName: "huainan",
    cityId: 113,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "H",
    GLng: 116.999958,
    status: 1,
  },
  {
    cityName: "黄冈",
    adCode: "421100",
    GLat: 30.453877,
    cityAbbrCode: "hg1",
    cityEnName: "huanggang",
    cityId: 185,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "H",
    GLng: 114.872253,
    status: 1,
  },
  {
    cityName: "黄山",
    adCode: "341000",
    GLat: 30.113961,
    cityAbbrCode: "hs7",
    cityEnName: "huangshan",
    cityId: 118,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "H",
    GLng: 118.1698,
    status: 1,
  },
  {
    cityName: "黄石",
    adCode: "420200",
    GLat: 30.199652,
    cityAbbrCode: "hs10",
    cityEnName: "huangshi",
    cityId: 177,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "H",
    GLng: 115.03852,
    status: 1,
  },
  {
    cityName: "呼和浩特",
    adCode: "150100",
    GLat: 40.84231,
    cityAbbrCode: "hh",
    cityEnName: "huhehaote",
    cityId: 46,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "H",
    GLng: 111.748847,
    status: 1,
  },
  {
    cityName: "惠州",
    adCode: "441300",
    GLat: 23.079404,
    cityAbbrCode: "hz5",
    cityEnName: "huizhou",
    cityId: 213,
    hotCity: false,
    regionCityId: 7,
    provinceId: 19,
    firstLetter: "H",
    GLng: 114.412599,
    status: 1,
  },
  {
    cityName: "葫芦岛",
    adCode: "211400",
    GLat: 40.710953,
    cityAbbrCode: "hld",
    cityEnName: "huludao",
    cityId: 69,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "H",
    GLng: 120.836827,
    status: 1,
  },
  {
    cityName: "呼伦贝尔",
    adCode: "150700",
    GLat: 49.211572,
    cityAbbrCode: "hl",
    cityEnName: "hulunbeier",
    cityId: 52,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "H",
    GLng: 119.765739,
    status: 1,
  },
  {
    cityName: "湖州",
    adCode: "330500",
    GLat: 30.89436,
    cityAbbrCode: "hz14",
    cityEnName: "huzhou",
    cityId: 103,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "H",
    GLng: 120.08681800000001,
    status: 1,
  },
  {
    cityName: "雅加达",
    GLat: -6.24705,
    cityAbbrCode: "cgk",
    cityEnName: "jakarta",
    cityId: 2353,
    hotCity: false,
    regionCityId: 4,
    provinceId: 111,
    firstLetter: "J",
    GLng: 106.8434,
    status: 1,
  },
  {
    cityName: "佳木斯",
    adCode: "230800",
    GLat: 46.799923,
    cityAbbrCode: "jms",
    cityEnName: "jiamusi",
    cityId: 86,
    hotCity: false,
    regionCityId: 2,
    provinceId: 8,
    firstLetter: "J",
    GLng: 130.318917,
    status: 1,
  },
  {
    cityName: "吉安",
    adCode: "360800",
    GLat: 27.113165,
    cityAbbrCode: "ja",
    cityEnName: "jian",
    cityId: 141,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "J",
    GLng: 114.993097,
    status: 1,
  },
  {
    cityName: "江门",
    adCode: "440700",
    GLat: 22.57877,
    cityAbbrCode: "jm1",
    cityEnName: "jiangmen",
    cityId: 209,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "J",
    GLng: 113.08187,
    status: 1,
  },
  {
    cityName: "抚州",
    adCode: "361000",
    GLat: 27.992296,
    cityAbbrCode: "fz4",
    cityEnName: "jiangxifuzhou",
    cityId: 143,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "J",
    GLng: 116.358378,
    status: 1,
  },
  {
    cityName: "宜春",
    adCode: "360900",
    GLat: 27.796561,
    cityAbbrCode: "yc12",
    cityEnName: "jiangxiyichun",
    cityId: 142,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "J",
    GLng: 114.395108,
    status: 1,
  },
  {
    cityName: "焦作",
    adCode: "410800",
    GLat: 35.215371,
    cityAbbrCode: "jz10",
    cityEnName: "jiaozuo",
    cityId: 167,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "J",
    GLng: 113.242058,
    status: 1,
  },
  {
    cityName: "嘉兴",
    adCode: "330400",
    GLat: 30.753924,
    cityAbbrCode: "jx12",
    cityEnName: "jiaxing",
    cityId: 102,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "J",
    GLng: 120.758543,
    status: 1,
  },
  {
    cityName: "揭阳",
    adCode: "445200",
    GLat: 23.549994,
    cityAbbrCode: "jy",
    cityEnName: "jieyang",
    cityId: 222,
    hotCity: false,
    regionCityId: 7,
    provinceId: 19,
    firstLetter: "J",
    GLng: 116.37283,
    status: 1,
  },
  {
    cityName: "吉林",
    adCode: "220200",
    GLat: 43.837883,
    cityAbbrCode: "jl",
    cityEnName: "jilin",
    cityId: 71,
    hotCity: false,
    regionCityId: 2,
    provinceId: 7,
    firstLetter: "J",
    GLng: 126.549572,
    status: 1,
  },
  {
    cityName: "济南",
    adCode: "370100",
    GLat: 36.665282,
    cityAbbrCode: "jn",
    cityEnName: "jinan",
    cityId: 22,
    hotCity: false,
    regionCityId: 155,
    provinceId: 15,
    firstLetter: "J",
    GLng: 116.994915,
    status: 1,
  },
  {
    cityName: "晋城",
    adCode: "140500",
    GLat: 35.49087,
    cityAbbrCode: "jc",
    cityEnName: "jincheng",
    cityId: 39,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "J",
    GLng: 112.85176800000002,
    status: 1,
  },
  {
    cityName: "景德镇",
    adCode: "360200",
    GLat: 29.307094,
    cityAbbrCode: "jdz",
    cityEnName: "jingdezhen",
    cityId: 135,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "J",
    GLng: 117.181566,
    status: 1,
  },
  {
    cityName: "荆州",
    adCode: "421000",
    GLat: 30.335165,
    cityAbbrCode: "jz12",
    cityEnName: "jingzhou",
    cityId: 184,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "J",
    GLng: 112.239741,
    status: 1,
  },
  {
    cityName: "金华",
    adCode: "330700",
    GLat: 29.079164,
    cityAbbrCode: "jh",
    cityEnName: "jinhua",
    cityId: 105,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "J",
    GLng: 119.647422,
    status: 1,
  },
  {
    cityName: "济宁",
    adCode: "370800",
    GLat: 35.414865,
    cityAbbrCode: "jn5",
    cityEnName: "jining",
    cityId: 150,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "J",
    GLng: 116.587075,
    status: 1,
  },
  {
    cityName: "晋江",
    adCode: "350500",
    GLat: 24.781611,
    cityAbbrCode: "jj1",
    cityEnName: "jinjiang",
    cityId: 1009,
    hotCity: false,
    regionCityId: 4,
    provinceId: 13,
    firstLetter: "J",
    GLng: 118.552433,
    status: 1,
  },
  {
    cityName: "荆门",
    adCode: "420800",
    GLat: 31.035423,
    cityAbbrCode: "jm",
    cityEnName: "jinmen",
    cityId: 182,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "J",
    GLng: 112.199265,
    status: 1,
  },
  {
    cityName: "晋中",
    adCode: "140700",
    GLat: 37.687204,
    cityAbbrCode: "jz",
    cityEnName: "jinzhong",
    cityId: 41,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "J",
    GLng: 112.752636,
    status: 1,
  },
  {
    cityName: "锦州",
    adCode: "210700",
    GLat: 41.095123,
    cityAbbrCode: "jz8",
    cityEnName: "jinzhou",
    cityId: 62,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "J",
    GLng: 121.12700999999998,
    status: 1,
  },
  {
    cityName: "九江",
    adCode: "360400",
    GLat: 29.705096,
    cityAbbrCode: "jj",
    cityEnName: "jiujiang",
    cityId: 137,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "J",
    GLng: 116.001982,
    status: 1,
  },
  {
    cityName: "酒泉",
    adCode: "620900",
    GLat: 39.732488,
    cityAbbrCode: "jq",
    cityEnName: "jiuquan",
    cityId: 307,
    hotCity: false,
    regionCityId: 17,
    provinceId: 28,
    firstLetter: "J",
    GLng: 98.494411,
    status: 1,
  },
  {
    cityName: "昆明",
    adCode: "530100",
    GLat: 25.037283,
    cityAbbrCode: "km",
    cityEnName: "kunming",
    cityId: 267,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "K",
    GLng: 102.722125,
    status: 3,
  },
  {
    cityName: "昆山",
    adCode: "320500",
    GLat: 31.387641,
    cityAbbrCode: "ks",
    cityEnName: "kunshan",
    cityId: 416,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "K",
    GLng: 120.982604,
    status: 1,
  },
  {
    cityName: "廊坊",
    adCode: "131000",
    GLat: 39.521017,
    cityAbbrCode: "lf",
    cityEnName: "langfang",
    cityId: 33,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "L",
    GLng: 116.706651,
    status: 1,
  },
  {
    cityName: "兰州",
    adCode: "620100",
    GLat: 36.061255,
    cityAbbrCode: "lz5",
    cityEnName: "lanzhou",
    cityId: 299,
    hotCity: false,
    regionCityId: 17,
    provinceId: 28,
    firstLetter: "L",
    GLng: 103.834377,
    status: 1,
  },
  {
    cityName: "拉斯维加斯",
    GLat: 36.208704,
    cityAbbrCode: "las",
    cityEnName: "lasvegas",
    cityId: 2398,
    hotCity: false,
    regionCityId: 1,
    provinceId: 118,
    firstLetter: "L",
    GLng: -115.188733,
    status: 1,
  },
  {
    cityName: "乐山",
    adCode: "511100",
    GLat: 29.552064,
    cityAbbrCode: "ls27",
    cityEnName: "leshan",
    cityId: 246,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "L",
    GLng: 103.765623,
    status: 1,
  },
  {
    cityName: "凉山",
    adCode: "513400",
    GLat: 27.881429,
    cityAbbrCode: "ls5",
    cityEnName: "liangshan",
    cityId: 257,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "L",
    GLng: 102.267726,
    status: 1,
  },
  {
    cityName: "连云港",
    adCode: "320700",
    GLat: 34.600018,
    cityAbbrCode: "lyg",
    cityEnName: "lianyuangang",
    cityId: 95,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "L",
    GLng: 119.178821,
    status: 1,
  },
  {
    cityName: "聊城",
    adCode: "371500",
    GLat: 36.456696,
    cityAbbrCode: "lc",
    cityEnName: "liaocheng",
    cityId: 157,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "L",
    GLng: 115.985371,
    status: 1,
  },
  {
    cityName: "丽江",
    adCode: "530700",
    GLat: 26.876774,
    cityAbbrCode: "lj",
    cityEnName: "lijiang",
    cityId: 279,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "L",
    GLng: 100.230376,
    status: 1,
  },
  {
    cityName: "陵水",
    adCode: "469028",
    GLat: 18.506048,
    cityAbbrCode: "ls13",
    cityEnName: "lingshui",
    cityId: 401,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "L",
    GLng: 110.037504,
    status: 1,
  },
  {
    cityName: "临夏市",
    adCode: "622900",
    GLat: 35.6045,
    cityAbbrCode: "lx14",
    cityEnName: "linxia",
    cityId: 2140,
    hotCity: false,
    regionCityId: 17,
    provinceId: 28,
    firstLetter: "L",
    GLng: 103.24317,
    status: 1,
  },
  {
    cityName: "临沂",
    adCode: "371300",
    GLat: 35.051712,
    cityAbbrCode: "ly20",
    cityEnName: "linyi",
    cityId: 155,
    hotCity: false,
    regionCityId: 155,
    provinceId: 15,
    firstLetter: "L",
    GLng: 118.347708,
    status: 3,
  },
  {
    cityName: "丽水",
    adCode: "331100",
    GLat: 28.451695,
    cityAbbrCode: "ls",
    cityEnName: "lishui",
    cityId: 109,
    hotCity: false,
    regionCityId: 11,
    provinceId: 11,
    firstLetter: "L",
    GLng: 119.916875,
    status: 1,
  },
  {
    cityName: "六安",
    adCode: "341500",
    GLat: 31.74501,
    cityAbbrCode: "la",
    cityEnName: "liuan",
    cityId: 123,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "L",
    GLng: 116.505686,
    status: 1,
  },
  {
    cityName: "柳州",
    adCode: "450200",
    GLat: 24.32551,
    cityAbbrCode: "lz",
    cityEnName: "liuzhou",
    cityId: 225,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "L",
    GLng: 109.415577,
    status: 1,
  },
  {
    cityName: "伦敦",
    GLat: 51.501584,
    cityAbbrCode: "ld10",
    cityEnName: "london",
    cityId: 2464,
    hotCity: false,
    regionCityId: 1,
    provinceId: 137,
    firstLetter: "L",
    GLng: -0.124454,
    status: 1,
  },
  {
    cityName: "娄底",
    adCode: "431300",
    GLat: 27.701693,
    cityAbbrCode: "ld",
    cityEnName: "loudi",
    cityId: 203,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "L",
    GLng: 111.996001,
    status: 1,
  },
  {
    cityName: "漯河",
    adCode: "411100",
    GLat: 33.581413,
    cityAbbrCode: "lh",
    cityEnName: "luohe",
    cityId: 170,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "L",
    GLng: 114.016539,
    status: 1,
  },
  {
    cityName: "洛阳",
    adCode: "410300",
    GLat: 34.618154,
    cityAbbrCode: "ly3",
    cityEnName: "luoyang",
    cityId: 162,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "L",
    GLng: 112.454363,
    status: 1,
  },
  {
    cityName: "泸州",
    adCode: "510500",
    GLat: 28.87176,
    cityAbbrCode: "lz19",
    cityEnName: "luzhou",
    cityId: 240,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "L",
    GLng: 105.442141,
    status: 1,
  },
  {
    cityName: "吕梁",
    adCode: "141100",
    GLat: 37.518972,
    cityAbbrCode: "ll",
    cityEnName: "lvliang",
    cityId: 45,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "L",
    GLng: 111.144138,
    status: 3,
  },
  {
    cityName: "马鞍山",
    adCode: "340500",
    GLat: 31.696788,
    cityAbbrCode: "mas",
    cityEnName: "maanshan",
    cityId: 114,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "M",
    GLng: 118.504657,
    status: 1,
  },
  {
    cityName: "马来西亚",
    GLat: 4.559998,
    cityAbbrCode: "my5",
    cityEnName: "malaysia",
    cityId: 2312,
    hotCity: false,
    regionCityId: 4,
    provinceId: 102,
    firstLetter: "M",
    GLng: 102.10611,
    status: 1,
  },
  {
    cityName: "茂名",
    adCode: "440900",
    GLat: 21.662956,
    cityAbbrCode: "mm",
    cityEnName: "maoming",
    cityId: 211,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "M",
    GLng: 110.925467,
    status: 1,
  },
  {
    cityName: "眉山",
    adCode: "511400",
    GLat: 30.076015,
    cityAbbrCode: "ms",
    cityEnName: "meishan",
    cityId: 248,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "M",
    GLng: 103.848462,
    status: 1,
  },
  {
    cityName: "梅州",
    adCode: "441400",
    GLat: 24.288531,
    cityAbbrCode: "mz",
    cityEnName: "meizhou",
    cityId: 214,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "M",
    GLng: 116.12245,
    status: 1,
  },
  {
    cityName: "绵阳",
    adCode: "510700",
    GLat: 31.463377,
    cityAbbrCode: "my",
    cityEnName: "mianyang",
    cityId: 242,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "M",
    GLng: 104.741274,
    status: 1,
  },
  {
    cityName: "莫斯科",
    GLat: 55.735104,
    cityAbbrCode: "mos",
    cityEnName: "moscow",
    cityId: 3150,
    hotCity: false,
    regionCityId: 1,
    provinceId: 162,
    firstLetter: "M",
    GLng: 37.631122,
    status: 1,
  },
  {
    cityName: "牡丹江",
    adCode: "231000",
    GLat: 44.587633,
    cityAbbrCode: "mdj",
    cityEnName: "mudanjiang",
    cityId: 88,
    hotCity: false,
    regionCityId: 2,
    provinceId: 8,
    firstLetter: "M",
    GLng: 129.614665,
    status: 1,
  },
  {
    cityName: "慕尼黑",
    GLat: 48.08,
    cityEnName: "Munich ",
    cityId: 4458,
    hotCity: false,
    regionCityId: 6,
    provinceId: 126,
    firstLetter: "M",
    GLng: 11.35,
    status: 1,
  },
  {
    cityName: "南昌",
    adCode: "360100",
    GLat: 28.676493,
    cityAbbrCode: "nc",
    cityEnName: "nanchang",
    cityId: 134,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "N",
    GLng: 115.892151,
    status: 1,
  },
  {
    cityName: "南充",
    adCode: "511300",
    GLat: 30.837888,
    cityAbbrCode: "nc1",
    cityEnName: "nanchong",
    cityId: 247,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "N",
    GLng: 106.110595,
    status: 1,
  },
  {
    cityName: "南京",
    adCode: "320100",
    GLat: 32.058365,
    cityAbbrCode: "nj",
    cityEnName: "nanjing",
    cityId: 5,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "N",
    GLng: 118.796468,
    status: 3,
  },
  {
    cityName: "南宁",
    adCode: "450100",
    GLat: 22.818012,
    cityAbbrCode: "nn",
    cityEnName: "nanning",
    cityId: 224,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "N",
    GLng: 108.365546,
    status: 1,
  },
  {
    cityName: "南平",
    adCode: "350700",
    GLat: 26.641671,
    cityAbbrCode: "np",
    cityEnName: "nanping",
    cityId: 131,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "N",
    GLng: 118.17739,
    status: 1,
  },
  {
    cityName: "南通",
    adCode: "320600",
    GLat: 31.979997,
    cityAbbrCode: "nt",
    cityEnName: "nantong",
    cityId: 94,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "N",
    GLng: 120.894324,
    status: 1,
  },
  {
    cityName: "南阳",
    adCode: "411300",
    GLat: 32.990615,
    cityAbbrCode: "ny",
    cityEnName: "nanyang",
    cityId: 172,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "N",
    GLng: 112.528345,
    status: 1,
  },
  {
    cityName: "内江",
    adCode: "511000",
    GLat: 29.580237,
    cityAbbrCode: "nj4",
    cityEnName: "neijiang",
    cityId: 245,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "N",
    GLng: 105.0583,
    status: 1,
  },
  {
    cityName: "宁波",
    adCode: "330200",
    GLat: 29.868336,
    cityAbbrCode: "nb",
    cityEnName: "ningbo",
    cityId: 11,
    hotCity: false,
    regionCityId: 11,
    provinceId: 11,
    firstLetter: "N",
    GLng: 121.54399,
    status: 3,
  },
  {
    cityName: "宁德",
    adCode: "350900",
    GLat: 26.666291,
    cityAbbrCode: "nd",
    cityEnName: "ningde",
    cityId: 133,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "N",
    GLng: 119.526287,
    status: 1,
  },
  {
    cityName: "大阪",
    GLat: 34.6767,
    cityAbbrCode: "osa",
    cityEnName: "osaka",
    cityId: 2374,
    hotCity: false,
    regionCityId: 1,
    provinceId: 105,
    firstLetter: "O",
    GLng: 135.497818,
    status: 1,
  },
  {
    cityName: "盘锦",
    adCode: "211100",
    GLat: 41.119998,
    cityAbbrCode: "pj",
    cityEnName: "panjin",
    cityId: 66,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "P",
    GLng: 122.070715,
    status: 1,
  },
  {
    cityName: "攀枝花",
    adCode: "510400",
    GLat: 26.582347,
    cityAbbrCode: "pzh",
    cityEnName: "panzhihua",
    cityId: 239,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "P",
    GLng: 101.718637,
    status: 1,
  },
  {
    cityName: "巴黎",
    GLat: 48.856667,
    cityAbbrCode: "par",
    cityEnName: "paris",
    cityId: 2388,
    hotCity: false,
    regionCityId: 8,
    provinceId: 117,
    firstLetter: "P",
    GLng: 2.350987,
    status: 1,
  },
  {
    cityName: "彭州市",
    GLat: 0,
    cityAbbrCode: "pz2",
    cityEnName: "pengzhou",
    cityId: 1605,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "P",
    GLng: 0,
    status: 1,
  },
  {
    cityName: "平顶山",
    adCode: "410400",
    GLat: 33.745244,
    cityAbbrCode: "pds",
    cityEnName: "pingdingshan",
    cityId: 163,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "P",
    GLng: 113.307006,
    status: 1,
  },
  {
    cityName: "萍乡",
    adCode: "360300",
    GLat: 27.622865,
    cityAbbrCode: "px",
    cityEnName: "pingxiang",
    cityId: 136,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "P",
    GLng: 113.854676,
    status: 1,
  },
  {
    cityName: "普洱",
    adCode: "530800",
    GLat: 22.78691,
    cityAbbrCode: "sm5",
    cityEnName: "puer",
    cityId: 275,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "P",
    GLng: 100.977165,
    status: 1,
  },
  {
    cityName: "普宁市",
    adCode: "445200",
    GLat: 23.29745,
    cityAbbrCode: "pn1",
    cityEnName: "puning",
    cityId: 1493,
    hotCity: false,
    regionCityId: 7,
    provinceId: 19,
    firstLetter: "P",
    GLng: 116.1657,
    status: 1,
  },
  {
    cityName: "莆田",
    adCode: "350300",
    GLat: 25.431011,
    cityAbbrCode: "pt",
    cityEnName: "putian",
    cityId: 127,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "P",
    GLng: 119.007558,
    status: 1,
  },
  {
    cityName: "黔东南",
    adCode: "522600",
    GLat: 26.58355,
    cityAbbrCode: "qdn",
    cityEnName: "qiandongnan",
    cityId: 265,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "Q",
    GLng: 107.982828,
    status: 1,
  },
  {
    cityName: "潜江",
    adCode: "429005",
    GLat: 30.40211,
    cityAbbrCode: "qj",
    cityEnName: "qianjiang",
    cityId: 190,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "Q",
    GLng: 112.900078,
    status: 1,
  },
  {
    cityName: "黔南",
    adCode: "522700",
    GLat: 26.254092,
    cityAbbrCode: "qn",
    cityEnName: "qiannan",
    cityId: 266,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "Q",
    GLng: 107.52214,
    status: 1,
  },
  {
    cityName: "黔西南",
    adCode: "522300",
    GLat: 25.087825,
    cityAbbrCode: "qxn",
    cityEnName: "qianxinan",
    cityId: 263,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "Q",
    GLng: 104.906397,
    status: 1,
  },
  {
    cityName: "青岛",
    adCode: "370200",
    GLat: 36.066348,
    cityAbbrCode: "qd",
    cityEnName: "qingdao",
    cityId: 21,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "Q",
    GLng: 120.382771,
    status: 1,
  },
  {
    cityName: "清远",
    adCode: "441800",
    GLat: 23.681801,
    cityAbbrCode: "qy",
    cityEnName: "qingyuan",
    cityId: 218,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Q",
    GLng: 113.056042,
    status: 1,
  },
  {
    cityName: "秦皇岛",
    adCode: "130300",
    GLat: 39.935377,
    cityAbbrCode: "qhd",
    cityEnName: "qinhuangdao",
    cityId: 26,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "Q",
    GLng: 119.600492,
    status: 1,
  },
  {
    cityName: "钦州",
    adCode: "450700",
    GLat: 21.980968,
    cityAbbrCode: "qz4",
    cityEnName: "qinzhou",
    cityId: 230,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "Q",
    GLng: 108.654543,
    status: 1,
  },
  {
    cityName: "泉州",
    adCode: "350500",
    GLat: 24.907398,
    cityAbbrCode: "qz3",
    cityEnName: "quanzhou",
    cityId: 129,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "Q",
    GLng: 118.587114,
    status: 1,
  },
  {
    cityName: "曲靖",
    adCode: "530300",
    GLat: 25.48999,
    cityAbbrCode: "qj1",
    cityEnName: "qujing",
    cityId: 268,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "Q",
    GLng: 103.796293,
    status: 1,
  },
  {
    cityName: "衢州",
    adCode: "330800",
    GLat: 28.935883,
    cityAbbrCode: "qz",
    cityEnName: "quzhou",
    cityId: 106,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "Q",
    GLng: 118.874018,
    status: 1,
  },
  {
    cityName: "日照",
    adCode: "371100",
    GLat: 35.416377,
    cityAbbrCode: "rz",
    cityEnName: "rizhao",
    cityId: 153,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "R",
    GLng: 119.526888,
    status: 1,
  },
  {
    cityName: "俄罗斯",
    GLat: 62.428794,
    cityAbbrCode: "rus",
    cityEnName: "russia",
    cityId: 3258,
    hotCity: false,
    regionCityId: 17,
    provinceId: 162,
    firstLetter: "R",
    GLng: 105.636719,
    status: 1,
  },
  {
    cityName: "三河市",
    adCode: "131000",
    GLat: 39.98246,
    cityAbbrCode: "sh4",
    cityEnName: "sanhe",
    cityId: 490,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "S",
    GLng: 117.07822,
    status: 1,
  },
  {
    cityName: "三明",
    adCode: "350400",
    GLat: 26.263938,
    cityAbbrCode: "sm",
    cityEnName: "sanming",
    cityId: 128,
    hotCity: false,
    regionCityId: 14,
    provinceId: 13,
    firstLetter: "S",
    GLng: 117.638857,
    status: 1,
  },
  {
    cityName: "三亚",
    adCode: "460200",
    GLat: 18.252847,
    cityAbbrCode: "sy13",
    cityEnName: "sanya",
    cityId: 345,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "S",
    GLng: 109.511909,
    status: 1,
  },
  {
    cityName: "圣彼得堡",
    GLat: 59.917101,
    cityAbbrCode: "sbdb",
    cityEnName: "sbdb",
    cityId: 4441,
    hotCity: false,
    regionCityId: 1,
    provinceId: 162,
    firstLetter: "S",
    GLng: 30.350463,
    status: 1,
  },
  {
    cityName: "首尔",
    GLat: 37.532871,
    cityAbbrCode: "sel",
    cityEnName: "seoul",
    cityId: 2369,
    hotCity: false,
    regionCityId: 2,
    provinceId: 104,
    firstLetter: "S",
    GLng: 126.980495,
    status: 1,
  },
  {
    cityName: "上海",
    adCode: "310100",
    GLat: 31.230708,
    cityAbbrCode: "sh",
    cityEnName: "shanghai",
    cityId: 1,
    hotCity: false,
    regionCityId: 1,
    provinceId: 9,
    firstLetter: "S",
    GLng: 121.472916,
    status: 3,
  },
  {
    cityName: "商丘",
    adCode: "411400",
    GLat: 34.414183,
    cityAbbrCode: "sq1",
    cityEnName: "shangqiu",
    cityId: 173,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "S",
    GLng: 115.656394,
    status: 3,
  },
  {
    cityName: "上饶",
    adCode: "361100",
    GLat: 28.443318,
    cityAbbrCode: "sr",
    cityEnName: "shangrao",
    cityId: 144,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "S",
    GLng: 117.976371,
    status: 1,
  },
  {
    cityName: "汕头",
    adCode: "440500",
    GLat: 23.353362,
    cityAbbrCode: "st",
    cityEnName: "shantou",
    cityId: 207,
    hotCity: false,
    regionCityId: 7,
    provinceId: 19,
    firstLetter: "S",
    GLng: 116.681943,
    status: 1,
  },
  {
    cityName: "汕尾",
    adCode: "441500",
    GLat: 22.785625,
    cityAbbrCode: "sw",
    cityEnName: "shanwei",
    cityId: 215,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "S",
    GLng: 115.375061,
    status: 1,
  },
  {
    cityName: "韶关",
    adCode: "440200",
    GLat: 24.811098,
    cityAbbrCode: "sg",
    cityEnName: "shaoguan",
    cityId: 205,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "S",
    GLng: 113.597299,
    status: 1,
  },
  {
    cityName: "绍兴",
    adCode: "330600",
    GLat: 29.995762,
    cityAbbrCode: "sx",
    cityEnName: "shaoxing",
    cityId: 104,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "S",
    GLng: 120.586109,
    status: 1,
  },
  {
    cityName: "邵阳",
    adCode: "430500",
    GLat: 27.239973,
    cityAbbrCode: "sy10",
    cityEnName: "shaoyang",
    cityId: 195,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "S",
    GLng: 111.468236,
    status: 1,
  },
  {
    cityName: "沈阳",
    adCode: "210100",
    GLat: 41.807321,
    cityAbbrCode: "sy",
    cityEnName: "shenyang",
    cityId: 18,
    hotCity: false,
    regionCityId: 18,
    provinceId: 6,
    firstLetter: "S",
    GLng: 123.43045,
    status: 3,
  },
  {
    cityName: "深圳",
    adCode: "440300",
    GLat: 22.543447,
    cityAbbrCode: "sz",
    cityEnName: "shenzhen",
    cityId: 7,
    hotCity: false,
    regionCityId: 7,
    provinceId: 19,
    firstLetter: "S",
    GLng: 114.057818,
    status: 3,
  },
  {
    cityName: "石家庄",
    adCode: "130100",
    GLat: 38.04232,
    cityAbbrCode: "sjz",
    cityEnName: "shijiazhuang",
    cityId: 24,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "S",
    GLng: 114.514864,
    status: 1,
  },
  {
    cityName: "十堰",
    adCode: "420300",
    GLat: 32.650381,
    cityAbbrCode: "sy7",
    cityEnName: "shiyan",
    cityId: 178,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "S",
    GLng: 110.788915,
    status: 1,
  },
  {
    cityName: "新加坡",
    GLat: 1.369041,
    cityAbbrCode: "sg4",
    cityEnName: "singapore",
    cityId: 2311,
    hotCity: false,
    regionCityId: 4,
    provinceId: 101,
    firstLetter: "S",
    GLng: 103.798433,
    status: 1,
  },
  {
    cityName: "遂宁",
    adCode: "510900",
    GLat: 30.52548,
    cityAbbrCode: "sn",
    cityEnName: "suining",
    cityId: 244,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "S",
    GLng: 105.568187,
    status: 1,
  },
  {
    cityName: "随州",
    adCode: "421300",
    GLat: 31.689958,
    cityAbbrCode: "sz7",
    cityEnName: "suizhou",
    cityId: 187,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "S",
    GLng: 113.382842,
    status: 1,
  },
  {
    cityName: "宿迁",
    adCode: "321300",
    GLat: 33.962083,
    cityAbbrCode: "sq",
    cityEnName: "suqian",
    cityId: 100,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "S",
    GLng: 118.275289,
    status: 1,
  },
  {
    cityName: "苏州",
    adCode: "320500",
    GLat: 31.297779,
    cityAbbrCode: "suz",
    cityEnName: "suzhou",
    cityId: 6,
    hotCity: false,
    regionCityId: 6,
    provinceId: 10,
    firstLetter: "S",
    GLng: 120.585586,
    status: 3,
  },
  {
    cityName: "悉尼",
    GLat: -33.87013,
    cityAbbrCode: "syd",
    cityEnName: "sydney",
    cityId: 2379,
    hotCity: false,
    regionCityId: 7,
    provinceId: 108,
    firstLetter: "S",
    GLng: 151.205864,
    status: 1,
  },
  {
    cityName: "泰安",
    adCode: "370900",
    GLat: 36.20002,
    cityAbbrCode: "ta",
    cityEnName: "taian",
    cityId: 151,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "T",
    GLng: 117.088115,
    status: 1,
  },
  {
    cityName: "中国台中",
    adCode: "710000",
    GLat: 24.15,
    cityAbbrCode: "tch",
    cityEnName: "taichung",
    cityId: 2341,
    hotCity: false,
    regionCityId: 7,
    provinceId: 34,
    firstLetter: "T",
    GLng: 120.666667,
    status: 1,
  },
  {
    cityName: "中国台北",
    adCode: "710000",
    GLat: 25.071295,
    cityAbbrCode: "tpe",
    cityEnName: "taipei",
    cityId: 2335,
    hotCity: false,
    regionCityId: 7,
    provinceId: 34,
    firstLetter: "T",
    GLng: 121.538315,
    status: 1,
  },
  {
    cityName: "太原",
    adCode: "140100",
    GLat: 37.870554,
    cityAbbrCode: "ty",
    cityEnName: "taiyuan",
    cityId: 35,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "T",
    GLng: 112.550737,
    status: 1,
  },
  {
    cityName: "泰州",
    GLat: 32.456584,
    cityAbbrCode: "tz",
    cityEnName: "taizhou",
    cityId: 99,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "T",
    GLng: 119.923046,
    status: 1,
  },
  {
    cityName: "唐山",
    adCode: "130200",
    GLat: 39.630476,
    cityAbbrCode: "ts",
    cityEnName: "tangshan",
    cityId: 25,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "T",
    GLng: 118.180407,
    status: 1,
  },
  {
    cityName: "泰国",
    GLat: 15.897942,
    cityAbbrCode: "th3",
    cityEnName: "thailand",
    cityId: 2313,
    hotCity: false,
    regionCityId: 7,
    provinceId: 103,
    firstLetter: "T",
    GLng: 101.092896,
    status: 1,
  },
  {
    cityName: "天津",
    adCode: "120100",
    GLat: 39.120876,
    cityAbbrCode: "tj",
    cityEnName: "tianjin",
    cityId: 10,
    hotCity: false,
    regionCityId: 2,
    provinceId: 2,
    firstLetter: "T",
    GLng: 117.21503,
    status: 3,
  },
  {
    cityName: "天水",
    adCode: "620500",
    GLat: 34.580862,
    cityAbbrCode: "ts4",
    cityEnName: "tianshui",
    cityId: 303,
    hotCity: false,
    regionCityId: 17,
    provinceId: 28,
    firstLetter: "T",
    GLng: 105.724947,
    status: 1,
  },
  {
    cityName: "铁岭",
    adCode: "211200",
    GLat: 42.286287,
    cityAbbrCode: "tl3",
    cityEnName: "tieling",
    cityId: 67,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "T",
    GLng: 123.842352,
    status: 1,
  },
  {
    cityName: "东京",
    GLat: 35.679052,
    cityAbbrCode: "tyo",
    cityEnName: "tokyo",
    cityId: 2372,
    hotCity: false,
    regionCityId: 1,
    provinceId: 105,
    firstLetter: "T",
    GLng: 139.768753,
    status: 1,
  },
  {
    cityName: "通化",
    adCode: "220500",
    GLat: 41.728401,
    cityAbbrCode: "th",
    cityEnName: "tonghua",
    cityId: 74,
    hotCity: false,
    regionCityId: 2,
    provinceId: 7,
    firstLetter: "T",
    GLng: 125.939697,
    status: 1,
  },
  {
    cityName: "同江市",
    adCode: "230800",
    GLat: 47.6421,
    cityAbbrCode: "tj1",
    cityEnName: "tongjiang",
    cityId: 796,
    hotCity: false,
    regionCityId: 2,
    provinceId: 8,
    firstLetter: "T",
    GLng: 132.51101,
    status: 1,
  },
  {
    cityName: "通辽",
    adCode: "150500",
    GLat: 43.61944,
    cityAbbrCode: "tl",
    cityEnName: "tongliao",
    cityId: 50,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "T",
    GLng: 122.265737,
    status: 1,
  },
  {
    cityName: "铜陵",
    GLat: 30.94453,
    cityAbbrCode: "tl5",
    cityEnName: "tongling",
    cityId: 116,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "T",
    GLng: 117.810841,
    status: 1,
  },
  {
    cityName: "铜仁市",
    adCode: "520600",
    GLat: 27.73156,
    cityAbbrCode: "tr",
    cityEnName: "tongren",
    cityId: 1770,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "T",
    GLng: 109.18962,
    status: 1,
  },
  {
    cityName: "铜仁地区",
    adCode: "520600",
    GLat: 27.731515,
    cityAbbrCode: "trd",
    cityEnName: "tongrendiqu",
    cityId: 262,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "T",
    GLng: 109.189598,
    status: 1,
  },
  {
    cityName: "万宁",
    adCode: "469006",
    GLat: 18.795143,
    cityAbbrCode: "wn1",
    cityEnName: "wanning",
    cityId: 407,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "W",
    GLng: 110.391073,
    status: 1,
  },
  {
    cityName: "潍坊",
    adCode: "370700",
    GLat: 36.706824,
    cityAbbrCode: "wf",
    cityEnName: "weifang",
    cityId: 149,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "W",
    GLng: 119.161929,
    status: 1,
  },
  {
    cityName: "威海",
    adCode: "371000",
    GLat: 37.513068,
    cityAbbrCode: "wh6",
    cityEnName: "weihai",
    cityId: 152,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "W",
    GLng: 122.12042,
    status: 1,
  },
  {
    cityName: "渭南",
    adCode: "610500",
    GLat: 34.499995,
    cityAbbrCode: "wn",
    cityEnName: "weinan",
    cityId: 293,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "W",
    GLng: 109.509786,
    status: 1,
  },
  {
    cityName: "温州",
    adCode: "330300",
    GLat: 27.994243,
    cityAbbrCode: "wz",
    cityEnName: "wenzhou",
    cityId: 101,
    hotCity: false,
    regionCityId: 11,
    provinceId: 11,
    firstLetter: "W",
    GLng: 120.699355,
    status: 1,
  },
  {
    cityName: "武汉",
    adCode: "420100",
    GLat: 30.593088,
    cityAbbrCode: "wh",
    cityEnName: "wuhan",
    cityId: 16,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "W",
    GLng: 114.305172,
    status: 3,
  },
  {
    cityName: "芜湖",
    adCode: "340200",
    GLat: 31.33879,
    cityAbbrCode: "wh5",
    cityEnName: "wuhu",
    cityId: 111,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "W",
    GLng: 118.385156,
    status: 1,
  },
  {
    cityName: "乌鲁木齐",
    adCode: "650100",
    GLat: 43.825666,
    cityAbbrCode: "wlm",
    cityEnName: "wulumuqi",
    cityId: 325,
    hotCity: false,
    regionCityId: 17,
    provinceId: 31,
    firstLetter: "W",
    GLng: 87.617298,
    status: 1,
  },
  {
    cityName: "无锡",
    adCode: "320200",
    GLat: 31.566148,
    cityAbbrCode: "wx",
    cityEnName: "wuxi",
    cityId: 13,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "W",
    GLng: 120.303027,
    status: 1,
  },
  {
    cityName: "五指山",
    adCode: "469001",
    GLat: 18.775147,
    cityAbbrCode: "wzs",
    cityEnName: "wuzhishan",
    cityId: 410,
    hotCity: false,
    regionCityId: 4,
    provinceId: 21,
    firstLetter: "W",
    GLng: 109.516925,
    status: 1,
  },
  {
    cityName: "梧州",
    adCode: "450400",
    GLat: 23.47691,
    cityAbbrCode: "wz2",
    cityEnName: "wuzhou",
    cityId: 227,
    hotCity: false,
    regionCityId: 4,
    provinceId: 20,
    firstLetter: "W",
    GLng: 111.27917,
    status: 1,
  },
  {
    cityName: "厦门",
    adCode: "350200",
    GLat: 24.479615,
    cityAbbrCode: "xm",
    cityEnName: "xiamen",
    cityId: 15,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "X",
    GLng: 118.08939,
    status: 1,
  },
  {
    cityName: "西安",
    adCode: "610100",
    GLat: 34.26488,
    cityAbbrCode: "xa",
    cityEnName: "xian",
    cityId: 17,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "X",
    GLng: 108.944265,
    status: 3,
  },
  {
    cityName: "中国香港",
    GLat: 22.282346,
    cityAbbrCode: "hk3",
    cityEnName: "xianggang",
    cityId: 341,
    hotCity: false,
    regionCityId: 341,
    provinceId: 32,
    firstLetter: "X",
    GLng: 114.172754,
    status: 3,
  },
  {
    cityName: "湘潭",
    adCode: "430300",
    GLat: 27.856325,
    cityAbbrCode: "xt4",
    cityEnName: "xiangtan",
    cityId: 193,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "X",
    GLng: 112.907339,
    status: 1,
  },
  {
    cityName: "襄阳",
    adCode: "420600",
    GLat: 32.023443,
    cityAbbrCode: "xy18",
    cityEnName: "xiangyang",
    cityId: 180,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "X",
    GLng: 112.155394,
    status: 1,
  },
  {
    cityName: "咸宁",
    adCode: "421200",
    GLat: 29.841447,
    cityAbbrCode: "xn",
    cityEnName: "xianning",
    cityId: 186,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "X",
    GLng: 114.322501,
    status: 1,
  },
  {
    cityName: "仙桃",
    adCode: "429004",
    GLat: 30.362641,
    cityAbbrCode: "xt3",
    cityEnName: "xiantao",
    cityId: 189,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "X",
    GLng: 113.454593,
    status: 1,
  },
  {
    cityName: "咸阳",
    adCode: "610400",
    GLat: 34.329434,
    cityAbbrCode: "xy21",
    cityEnName: "xianyang",
    cityId: 292,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "X",
    GLng: 108.709193,
    status: 1,
  },
  {
    cityName: "孝感",
    adCode: "420900",
    GLat: 30.924572,
    cityAbbrCode: "xg",
    cityEnName: "xiaogan",
    cityId: 183,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "X",
    GLng: 113.9169,
    status: 1,
  },
  {
    cityName: "西昌市",
    adCode: "513400",
    GLat: 27.894496,
    cityAbbrCode: "xc9",
    cityEnName: "xichang",
    cityId: 382,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "X",
    GLng: 102.264443,
    status: 1,
  },
  {
    cityName: "兴安盟",
    adCode: "152200",
    GLat: 46.077561,
    cityAbbrCode: "xa1",
    cityEnName: "xingan",
    cityId: 53,
    hotCity: false,
    regionCityId: 2,
    provinceId: 5,
    firstLetter: "X",
    GLng: 122.067042,
    status: 1,
  },
  {
    cityName: "邢台",
    adCode: "130500",
    GLat: 37.070589,
    cityAbbrCode: "xt",
    cityEnName: "xingtai",
    cityId: 28,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "X",
    GLng: 114.504874,
    status: 1,
  },
  {
    cityName: "兴义市",
    adCode: "522300",
    GLat: 25.09194,
    cityAbbrCode: "xy4",
    cityEnName: "xingyi",
    cityId: 1807,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "X",
    GLng: 104.89529,
    status: 1,
  },
  {
    cityName: "西宁",
    adCode: "630100",
    GLat: 36.61708500000001,
    cityAbbrCode: "xn3",
    cityEnName: "xining",
    cityId: 313,
    hotCity: false,
    regionCityId: 17,
    provinceId: 29,
    firstLetter: "X",
    GLng: 101.778208,
    status: 1,
  },
  {
    cityName: "新乡",
    adCode: "410700",
    GLat: 35.303318,
    cityAbbrCode: "xx",
    cityEnName: "xinxiang",
    cityId: 166,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "X",
    GLng: 113.926924,
    status: 1,
  },
  {
    cityName: "信阳",
    adCode: "411500",
    GLat: 32.123233,
    cityAbbrCode: "xy14",
    cityEnName: "xinyang",
    cityId: 174,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "X",
    GLng: 114.068871,
    status: 1,
  },
  {
    cityName: "新余",
    adCode: "360500",
    GLat: 27.817823,
    cityAbbrCode: "xy",
    cityEnName: "xinyu",
    cityId: 138,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "X",
    GLng: 114.91741,
    status: 1,
  },
  {
    cityName: "忻州",
    adCode: "140900",
    GLat: 38.416364,
    cityAbbrCode: "xz",
    cityEnName: "xinzhou",
    cityId: 43,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "X",
    GLng: 112.734269,
    status: 1,
  },
  {
    cityName: "西双版纳",
    adCode: "532800",
    GLat: 22.008178,
    cityAbbrCode: "xsb",
    cityEnName: "xishuangbanna",
    cityId: 276,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "X",
    GLng: 100.797283,
    status: 1,
  },
  {
    cityName: "宣城",
    adCode: "341800",
    GLat: 30.940718,
    cityAbbrCode: "xc",
    cityEnName: "xuancheng",
    cityId: 126,
    hotCity: false,
    regionCityId: 5,
    provinceId: 12,
    firstLetter: "X",
    GLng: 118.758816,
    status: 1,
  },
  {
    cityName: "许昌",
    adCode: "411000",
    GLat: 34.035608,
    cityAbbrCode: "xc7",
    cityEnName: "xuchang",
    cityId: 169,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "X",
    GLng: 113.85394,
    status: 1,
  },
  {
    cityName: "徐州",
    adCode: "320300",
    GLat: 34.259827,
    cityAbbrCode: "xz5",
    cityEnName: "xuzhou",
    cityId: 92,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "X",
    GLng: 117.19108,
    status: 1,
  },
  {
    cityName: "雅安",
    adCode: "511800",
    GLat: 29.980514,
    cityAbbrCode: "ya",
    cityEnName: "yaan",
    cityId: 252,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "Y",
    GLng: 103.013163,
    status: 1,
  },
  {
    cityName: "盐城",
    adCode: "320900",
    GLat: 33.347416,
    cityAbbrCode: "yc8",
    cityEnName: "yancheng",
    cityId: 97,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "Y",
    GLng: 120.163544,
    status: 1,
  },
  {
    cityName: "阳江",
    adCode: "441700",
    GLat: 21.857662,
    cityAbbrCode: "yj",
    cityEnName: "yangjiang",
    cityId: 217,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Y",
    GLng: 111.982536,
    status: 1,
  },
  {
    cityName: "阳泉",
    adCode: "140300",
    GLat: 37.856658,
    cityAbbrCode: "yq",
    cityEnName: "yangquan",
    cityId: 37,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "Y",
    GLng: 113.580415,
    status: 1,
  },
  {
    cityName: "扬州",
    adCode: "321000",
    GLat: 32.394237,
    cityAbbrCode: "yz",
    cityEnName: "yangzhou",
    cityId: 12,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "Y",
    GLng: 119.412854,
    status: 1,
  },
  {
    cityName: "延吉市",
    adCode: "222400",
    GLat: 42.906921,
    cityAbbrCode: "yj10",
    cityEnName: "yanji",
    cityId: 361,
    hotCity: false,
    regionCityId: 2,
    provinceId: 7,
    firstLetter: "Y",
    GLng: 129.513902,
    status: 1,
  },
  {
    cityName: "烟台",
    adCode: "370600",
    GLat: 37.539297,
    cityAbbrCode: "yt6",
    cityEnName: "yantai",
    cityId: 148,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "Y",
    GLng: 121.391382,
    status: 1,
  },
  {
    cityName: "宜宾",
    adCode: "511500",
    GLat: 28.751853,
    cityAbbrCode: "yb1",
    cityEnName: "yibin",
    cityId: 249,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "Y",
    GLng: 104.643418,
    status: 1,
  },
  {
    cityName: "宜昌",
    adCode: "420500",
    GLat: 30.691967,
    cityAbbrCode: "yc16",
    cityEnName: "yichang",
    cityId: 179,
    hotCity: false,
    regionCityId: 16,
    provinceId: 17,
    firstLetter: "Y",
    GLng: 111.286471,
    status: 1,
  },
  {
    cityName: "银川",
    adCode: "640100",
    GLat: 38.487194,
    cityAbbrCode: "yc20",
    cityEnName: "yinchuan",
    cityId: 321,
    hotCity: false,
    regionCityId: 17,
    provinceId: 30,
    firstLetter: "Y",
    GLng: 106.230909,
    status: 1,
  },
  {
    cityName: "营口",
    adCode: "210800",
    GLat: 40.666989,
    cityAbbrCode: "yk",
    cityEnName: "yingkou",
    cityId: 63,
    hotCity: false,
    regionCityId: 2,
    provinceId: 6,
    firstLetter: "Y",
    GLng: 122.235286,
    status: 1,
  },
  {
    cityName: "鹰潭",
    adCode: "360600",
    GLat: 28.260189,
    cityAbbrCode: "yt",
    cityEnName: "yingtan",
    cityId: 139,
    hotCity: false,
    regionCityId: 344,
    provinceId: 14,
    firstLetter: "Y",
    GLng: 117.069202,
    status: 1,
  },
  {
    cityName: "义乌",
    adCode: "330700",
    GLat: 29.306841,
    cityAbbrCode: "yw",
    cityEnName: "yiwu",
    cityId: 385,
    hotCity: false,
    regionCityId: 3,
    provinceId: 11,
    firstLetter: "Y",
    GLng: 120.075058,
    status: 1,
  },
  {
    cityName: "益阳",
    adCode: "430900",
    GLat: 28.580483,
    cityAbbrCode: "yy8",
    cityEnName: "yiyang",
    cityId: 199,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "Y",
    GLng: 112.355338,
    status: 1,
  },
  {
    cityName: "岳阳",
    adCode: "430600",
    GLat: 29.356983,
    cityAbbrCode: "yy",
    cityEnName: "yueyang",
    cityId: 196,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "Y",
    GLng: 113.12887699999999,
    status: 1,
  },
  {
    cityName: "榆林",
    adCode: "610800",
    GLat: 38.285526,
    cityAbbrCode: "yl4",
    cityEnName: "yulin",
    cityId: 296,
    hotCity: false,
    regionCityId: 17,
    provinceId: 27,
    firstLetter: "Y",
    GLng: 109.735209,
    status: 1,
  },
  {
    cityName: "运城",
    adCode: "140800",
    GLat: 35.026372,
    cityAbbrCode: "yc",
    cityEnName: "yuncheng",
    cityId: 42,
    hotCity: false,
    regionCityId: 17,
    provinceId: 4,
    firstLetter: "Y",
    GLng: 111.007324,
    status: 1,
  },
  {
    cityName: "云浮",
    adCode: "445300",
    GLat: 22.914989,
    cityAbbrCode: "yf",
    cityEnName: "yunfu",
    cityId: 223,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Y",
    GLng: 112.044335,
    status: 1,
  },
  {
    cityName: "玉溪",
    adCode: "530400",
    GLat: 24.352036,
    cityAbbrCode: "yx",
    cityEnName: "yuxi",
    cityId: 269,
    hotCity: false,
    regionCityId: 267,
    provinceId: 25,
    firstLetter: "Y",
    GLng: 102.546543,
    status: 1,
  },
  {
    cityName: "枣庄",
    adCode: "370400",
    GLat: 34.8105,
    cityAbbrCode: "zz9",
    cityEnName: "zaozhuang",
    cityId: 146,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "Z",
    GLng: 117.323725,
    status: 1,
  },
  {
    cityName: "张家界",
    adCode: "430800",
    GLat: 29.116337,
    cityAbbrCode: "zjj",
    cityEnName: "zhangjiajie",
    cityId: 198,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "Z",
    GLng: 110.479111,
    status: 1,
  },
  {
    cityName: "张家口",
    adCode: "130700",
    GLat: 40.767576,
    cityAbbrCode: "zjk",
    cityEnName: "zhangjiakou",
    cityId: 30,
    hotCity: false,
    regionCityId: 2,
    provinceId: 3,
    firstLetter: "Z",
    GLng: 114.885951,
    status: 1,
  },
  {
    cityName: "章丘",
    adCode: "370100",
    GLat: 36.7142,
    cityAbbrCode: "zq3",
    cityEnName: "zhangqiu",
    cityId: 1118,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "Z",
    GLng: 117.53434,
    status: 1,
  },
  {
    cityName: "漳州",
    adCode: "350600",
    GLat: 24.513321,
    cityAbbrCode: "zz",
    cityEnName: "zhangzhou",
    cityId: 130,
    hotCity: false,
    regionCityId: 7,
    provinceId: 13,
    firstLetter: "Z",
    GLng: 117.647363,
    status: 1,
  },
  {
    cityName: "湛江",
    adCode: "440800",
    GLat: 21.270764,
    cityAbbrCode: "zj3",
    cityEnName: "zhanjiang",
    cityId: 210,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Z",
    GLng: 110.359255,
    status: 1,
  },
  {
    cityName: "肇庆",
    adCode: "441200",
    GLat: 23.047596,
    cityAbbrCode: "zq",
    cityEnName: "zhaoqing",
    cityId: 212,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Z",
    GLng: 112.465166,
    status: 1,
  },
  {
    cityName: "台州",
    adCode: "331000",
    GLat: 28.828501,
    cityAbbrCode: "tz2",
    cityEnName: "zhejiangtaizhou",
    cityId: 108,
    hotCity: false,
    regionCityId: 11,
    provinceId: 11,
    firstLetter: "Z",
    GLng: 121.175834,
    status: 1,
  },
  {
    cityName: "郑州",
    adCode: "410100",
    GLat: 34.747285,
    cityAbbrCode: "zz11",
    cityEnName: "zhengzhou",
    cityId: 160,
    hotCity: false,
    regionCityId: 160,
    provinceId: 16,
    firstLetter: "Z",
    GLng: 113.624863,
    status: 3,
  },
  {
    cityName: "镇江",
    adCode: "321100",
    GLat: 32.199789,
    cityAbbrCode: "zj",
    cityEnName: "zhenjiang",
    cityId: 98,
    hotCity: false,
    regionCityId: 5,
    provinceId: 10,
    firstLetter: "Z",
    GLng: 119.456928,
    status: 1,
  },
  {
    cityName: "中山",
    adCode: "442000",
    GLat: 22.516481,
    cityAbbrCode: "zs6",
    cityEnName: "zhongshan",
    cityId: 220,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Z",
    GLng: 113.392756,
    status: 1,
  },
  {
    cityName: "舟山",
    adCode: "330900",
    GLat: 29.985444,
    cityAbbrCode: "zs",
    cityEnName: "zhoushan",
    cityId: 107,
    hotCity: false,
    regionCityId: 11,
    provinceId: 11,
    firstLetter: "Z",
    GLng: 122.206596,
    status: 1,
  },
  {
    cityName: "珠海",
    adCode: "440400",
    GLat: 22.27094,
    cityAbbrCode: "zh",
    cityEnName: "zhuhai",
    cityId: 206,
    hotCity: false,
    regionCityId: 4,
    provinceId: 19,
    firstLetter: "Z",
    GLng: 113.577261,
    status: 1,
  },
  {
    cityName: "株洲",
    adCode: "430200",
    GLat: 27.827892,
    cityAbbrCode: "zz2",
    cityEnName: "zhuzhou",
    cityId: 192,
    hotCity: false,
    regionCityId: 344,
    provinceId: 18,
    firstLetter: "Z",
    GLng: 113.133891,
    status: 1,
  },
  {
    cityName: "淄博",
    adCode: "370300",
    GLat: 36.813497,
    cityAbbrCode: "zb",
    cityEnName: "zibo",
    cityId: 145,
    hotCity: false,
    regionCityId: 2,
    provinceId: 15,
    firstLetter: "Z",
    GLng: 118.055007,
    status: 1,
  },
  {
    cityName: "自贡",
    adCode: "510300",
    GLat: 29.338978,
    cityAbbrCode: "zg",
    cityEnName: "zigong",
    cityId: 238,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "Z",
    GLng: 104.778564,
    status: 1,
  },
  {
    cityName: "资阳",
    adCode: "512000",
    GLat: 30.129463,
    cityAbbrCode: "zy",
    cityEnName: "ziyang",
    cityId: 254,
    hotCity: false,
    regionCityId: 8,
    provinceId: 23,
    firstLetter: "Z",
    GLng: 104.628889,
    status: 1,
  },
  {
    cityName: "遵义",
    adCode: "520300",
    GLat: 27.725654,
    cityAbbrCode: "zy5",
    cityEnName: "zunyi",
    cityId: 260,
    hotCity: false,
    regionCityId: 8,
    provinceId: 24,
    firstLetter: "Z",
    GLng: 106.927389,
    status: 1,
  },
];



// WEBPACK FOOTER //
// ./src/mods/citiesData.js